import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel,
  InputAdornment,
  Alert,
  CircularProgress,
  Backdrop,
  ListItemText,
  Autocomplete,
  Paper,
  createFilterOptions,
} from '@mui/material';
import printJS from 'print-js';
import { API, graphqlOperation } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { useLocation } from 'react-router-dom';
import TeaxtareaField from '../../components/formElements/TeaxtareaField';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import { baseQueryv2 as baseQuery } from '../../redux/baseQuery';

import {
  listInvoiceMaster,
  getInvoiceMaster,
  getCrDrNoteMaster,
  getLinkedReceipts,
  listTransactionRelation,
  deleteTransactionMaster,
  getMinMaxInvoiceDate,
  getTransactionMasterV2,
  createTransactionAttachment,
  createTransactionWithSpecificTimev2,
  getLastUsedBankOrCashAccount,
} from '../../graphql';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import LinkToSalesInvoice from '../../components/modals/LinkToSalesInvoice';
import { MoneyFormatv3, getWords } from '../../library/MoneyFormat';
import ConfirmCancel from '../../components/modals/confirmCancel';
import PercentIcon from '@mui/icons-material/Percent';
import Grid from '@mui/material/Grid';
import { AccountInputv2, AccountInput } from '../../components/formElements/AccountInput';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { HeadingWithRuler, PageTitle } from '../../components/Ui/Ui';
import { uploadToServer } from '../../library/upload';
import PreviewSalesTaxable from '../../components/modals/PreviewSalesTaxable';
import CheckIcon from '@mui/icons-material/Check';
import { makeStyles } from '@mui/styles';

import AddAccountModal from './Modals/AddAccountModal';
import AddBankAccountModal from './Modals/AddBankAccountModal';
import MoneyInput from '../../components/formElements/moneyFormatInput';
import ConfirmExit from '../../components/modals/ConfirmExit';
import Attachment from '../NewFigma/AddCustomer/attachment';
import ToolTipComponent from './Components/ToolTipComponent';
import InvoiceCancel from '../../components/modals/InvoiceCancel';
import DraggableAction from '../../components/Buttons/DraggableAction';
import LinkingTable from '../../components/Table/LinkingTable';
import { useThemes } from '../../components/Theme/theme';
import useSaveShortcut from '../../hooks/useSaveShortcut';
import { setNavigationBlocked } from '../../redux/reducers/controllNavigation';
import {
  getCompanyCodeTranslation,
  listAccountMasterv2Custom,
  listPartyAndTransactionMastersCustomRec,
  getAccountBalance,
  listPartymasters,
  listVoucherSerialNumbers,
  listTransactionMasterv2,
  getTransactionMaster,
  getTransactionTDSDetails,
  getReceiptDetails,
  getTransactionRelationWithAccountID,
  createTransactionRelation,
  createTransactionWithSpecificTime,
  listPartyInvoicePurchases,
} from '../../graphql';
import { listAccountMasterv2Api, useListAccountMasterv2Query } from '../../redux/apis/accountMaster.api';
import { useListGeneralSettingQuery, useListVoucherSerialNumbersQuery, VoucherSettingsApi } from '../../redux/apis/newVoucherSettings.api';
import CreateAndEditLedger from '../../components/modals/CreateAndEditLedger';
import NewVoucherSettingsModal from './Modals/newVoucherSettingModal';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import { paymentApi, useGetLastUsedBankOrCashAccountQuery, useGetMinMaxInvoiceDateQuery } from '../../features/Payment/api/payment.api';
import { baseQueryv2 } from '../../redux/baseQuery';
import { LedgerTransactionModalv2 } from '../LedgerTransaction';
import dayjs from 'dayjs';
import { fetchAndPrintPDF } from '../../utils/common';
import moment from 'moment';
import API_ENDPOINTS from '../../apiEndpoints';
import SummaryDialog from '../../components/modals/SummaryDialog';
import CustomTooltip from '../../components/CustomTooltip';
import useSaveShortcutV1 from '../../hooks/useSaveShortcutV1';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import { ReceiptPrint } from '../../library/InvoicePrint';
import CancelUI from '../../components/Ui/CancelUI';
import { updateTitle } from '../../redux/reducers/titleSlice';
import './Components/Invoice.css';
import { CheckVoucherValid } from './Components/CheckVoucherValid';
import { useListCompanyPreferenceQuery } from '../../redux/apis/companyPreference.api';
import { DEFAULT_DATE_FORMAT } from '../../config';

let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;
const useStyles = makeStyles((theme) => ({
  root: {
    '&.css-1v7lraa-MuiPaper-root': {
      borderRadius: '15px',
    },
  },
  check: {
    '&.css-i4bv87-MuiSvgIcon-root': {
      fontSize: '20px',
      // color: "red",
    },
    color: 'red!important',
  },
  accordionRoot: {
    '&.MuiAccordion-root': {
      boxShadow: 'none',
    },
    '&.MuiAccordionSummary-content': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid black',
    },
  },

  accordionSummary: {
    '& .MuiAccordionSummary-expandIconWrapper': {
      backgroundColor: 'lightgrey',
      borderRadius: '50%',
    },
  },
}));

function AddNewReceipts({ modalData, onSaveComplete, receivedFrom, receivedTo, method = 'CashReceipt' }) {
  const [createPdf, progress] = useCreatePdfMutation();
  const { theme } = useThemes();
  // const navigate = useNavigate();
  const navigate = useControlledNavigation();

  const dispatch = useDispatch();
  const imageRef = useRef();
  dispatch(display());
  const classes = useStyles();

  let location = useLocation();
  const params = location.state || {
    id: parseInt(new URLSearchParams(window.location.search).get('transaction')),
    view: parseInt(new URLSearchParams(window.location.search).get('transaction')) ? true : false,
    // pdflink: new URLSearchParams(window.location.search).get("pdflink") || "",
  };

  if (!onSaveComplete) {
    if (params?.partyID) {
      onSaveComplete = () => navigate('/salesInvoiceReport', { force: true });
    } else {
      onSaveComplete = () => navigate('/receipts', { force: true });
    }
  }

  const { Enable_ItemWiseEntry } = useSelector((state) => state.paymentSettingsReducer);
  const userPreferenceAndFY = useSelector((state) => state?.userPrefrenceandReducer);

  const { data: companyPreference } = useListCompanyPreferenceQuery();
  const postingDatePref = companyPreference?.find(
    (p) =>
      p.attributetypecd === 'MyPostingDate' &&
      String(p?.additionalvalue ?? '') === String(userPreferenceAndFY?.financialYear?.financialyearid ?? '')
  );
  const savedPostingDate = postingDatePref?.attributevalue;
  const [backdropOpen, setBackdropOpen] = useState(true);
  // const [accountName, setAccountName] = useState([
  //   {
  //     label: params.name ? params.name : "",
  //     value: params.partyID ? params.partyID : "",
  //     AccountTypeFlag: params.partyID ? 2 : "",
  //   },
  // ]);
  const [paymentFlag, setPaymentFlag] = useState(true);
  // const [cashAccount, setCashAccount] = useState([]);
  // const [bankAccount, setBankAccount] = useState([]);
  const [openCaptureTCSTDS, setopenCaptureTCSTDS] = useState(false);
  const [crDrDetails, setCrDrDetails] = useState({});
  const randomNum = Math.floor(Math.random() * 100 + 1);
  const timeStamp = Math.floor(new Date().getTime() / 1000);
  const randomNumber = randomNum + timeStamp.toString().slice(3, 10);
  const [entries, setEntries] = useState([]);
  const [entryStamp, setEntryStamp] = useState('');
  const [fromAccountModal, setFromAccountModal] = useState(false);
  const [openBankModal, setOpenBankModal] = useState(false);
  const [accountFlag, setAccountFlag] = useState(false);
  const [tdsSection, setTdsSection] = useState([]);
  const [fromBalanceAmount, setFromBalanceAmount] = useState(0);
  const [toBalanceAmount, setToBalanceAmount] = useState(0);
  const [accountIDTransaction, setAccountIDTransaction] = useState('');
  const [linkToInvoiceModal, setLinkToInvoiceModal] = useState(false);
  const [accountID, setAccountID] = useState(0);
  const [entryData, setEntryData] = useState([]);
  const [transArr, setTransArr] = useState('');
  const [linkedData, setLinkedData] = useState([]);
  const [partylist, setPartyList] = useState([]);
  const [customerID, setCustomerID] = useState('');
  const [creditData, setCreditData] = useState([]);
  const [debitData, setDebitData] = useState([]);
  const [viewMode, setViewMode] = useState(false);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [previewReceiptModal, setPreviewReceiptModal] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [currentPaymentFlag, setCurrentPaymentFlag] = useState(false);
  const [currentBankRefNo, setCurrentBankRefNo] = useState('');
  const [cancelModal, setCancelModal] = useState(false);
  const [generalSettingsFlag, setGeneralSettingsFlag] = useState(-1);
  const [settingsModal, setSettingsModal] = useState();
  const [receiptVoucherNos, setReceiptVoucherNos] = useState([]);
  const [accountType, setAccountType] = useState('');
  const [vouchNo, setVouchNo] = useState('');
  const [selelctedGroupId, setSelectedGroupId] = useState('');
  const [newPartyID, setNewPartyID] = useState('');
  const [newPartyName, setNewPartyName] = useState('');
  const [openModalEvent, setOpenModalEvent] = useState(false);
  const [cashAccountObj, setCashAccountObj] = useState();
  const [bankAccountObj, setBankAccountObj] = useState();
  const [serialNos, setSerialNos] = useState([]);
  const [activeVouchers, setActiveVouchers] = useState([]);
  const [tdsID, setTdsID] = useState('');
  const companyDetail = useSelector((state) => state?.companyReducer.companyDetails);
  const [data, setData] = useState({
    reason: '',
    errorFields: {
      reason: '',
    },
    errorStatus: {
      reason: false,
    },
  });
  const [invoiceEntry, setInvoiceEntry] = useState([]);
  const [cancelModalStatus, setCancelModalStatus] = useState(false);
  const [itemData, setItemData] = useState({});
  const [deleteItemModal, setDeleteItemModal] = useState(false);
  const [isVoucherEditable, setisVoucherEditable] = useState(false);
  const [SummaryData, setSummaryData] = useState({
    open: false,
    description: '',
    lists: [],
    title: '',
  });
  const cancel = async (id, type, voucherNo) => {
    return new Promise(async (resolve, reject) => {
      try {
        saveEditChanges({ toCancel: 1, CancelRemark: state.reason });
      } catch (error) {
        showErrorSnackbar('Something Went Wrong !');
        console.log(error);
      } finally {
        resolve();
      }
    });
  };
  async function deleteEntry(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(deleteTransactionMaster, {
          transactionid: data?.id,
        })
      );
      if (res.data?.deleteTransactionMaster != null) {
        if (data.nav) {
          dispatch(setNavigationBlocked(false));
          navigate(data.nav, { force: true });
        }
        showSuccessSnackbar(`${data.label} Voucher deleted Successfully`);
        dispatch(dashboardApi.util.invalidateTags(['dashboard',"bizview"]));
      } else {
        alert('Item not Deleted.! something went wrong. please try again');
      }
      // console.log(res);
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  }
  useEffect(() => {
    if (params?.id) {
      setViewMode(params?.view);
      setBackdropOpen(true);
      getEntryData(params?.id);
    }
    setAttachments([]);

    return () => {
      // localStorage.removeItem("PaymentTransactionID");
      // localStorage.removeItem("PaymentViewMode");
    };
  }, []);

  useEffect(() => {
    if (modalData) {
      setState((prev) => ({
        ...prev,
        receivedFrom: { label: modalData?.name, value: modalData.id },
        errorStatus: {
          ...prev.errorStatus,
          receivedFrom: false,
        },
        errorFields: {
          ...prev.errorFields,
          receivedFrom: '',
        },
      }));
    }
  }, [modalData]);
  const invalidateAllVoucherSerialNumbers = () => {
    dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'VoucherSerialNumbers', id: 'ALL' }]));
    dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listGeneralSettings', id: 'ALL' }]));
  };
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/`;

  useEffect(() => {
    setCompanyDetails(companyDetail);
    return () => {};
  }, [companyDetail]);

  const id = receivedFrom?.value || params?.partyID;
  useEffect(() => {
    if (id) {
      getTransactions(id, null, params?.invoiceNumber);
    }
    return () => {};
  }, [id]);

  const [initialState, setInitialState] = useState({
    vouchernumber: '',
    // date: todayDate,
    date: '',
    method: method ?? 'CashReceipt',
    receivedFrom: receivedFrom ?? {
      label: params.name ? params.name : '',
      value: params.partyID ? params.partyID : '',
      AccountTypeFlag: params.partyID ? 2 : '',
    },
    receivedTo:
      receivedTo ??
      (method === 'CashReceipt'
        ? { label: 'Cash A/c', value: 3, AccountTypeFlag: '' }
        : { label: 'Bank A/c', value: 39, AccountTypeFlag: '' }),
    receivableAmount: '',
    tds: '',
    TDSManual: 0,
    tdsApplicable: '',
    tdsAmount: '',
    receivedAmount: '',
    bankRefNo: '',
    remarks: '',
    attachment: '',
    seriesVouchers: { label: '', value: '' },
    TDSPercentage: 0,
    TAN: '',
    PartyName: '',
    Towards: '',
    errorStatus: {
      vouchernumber: false,
      date: false,
      method: false,
      receivedFrom: false,
      receivedTo: false,
      receivableAmount: false,
      tds: '',
      tdsApplicable: false,
      tdsAmount: false,
      receivedAmount: false,
      bankRefNo: false,
      remarks: false,
      attachment: false,
      seriesVouchers: false,
      TDSPercentage: false,
      narration: false,
    },
    errorFields: {
      vouchernumber: '',
      date: '',
      method: '',
      receivedFrom: '',
      receivedTo: '',
      receivableAmount: '',
      tds: '',
      tdsApplicable: '',
      tdsAmount: '',
      receivedAmount: '',
      bankRefNo: '',
      remarks: '',
      attachment: '',
      seriesVouchers: '',
      TDSPercentage: '',
      narration: '',
    },
  });
  const [state, setState] = useState({ ...initialState });
  const [companyFinYrStartDate, setCompanyFinYrStartDate] = useState('');
  const [companyFinYrEndDate, setCompanyFinYrEndDate] = useState('');
  const [initialAttachments, setInitialAttachments] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [currentDocuments, setCurrentDocuments] = useState([]);
  console.log({ initialState, state });
  const updateAttachmentName = (id, newName) => {
    setAttachments(
      attachments.map((attachment) => (attachment.attachmentid === id ? { ...attachment, documentname: newName } : attachment))
    );
  };

  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  // const [LastBankAccount, setLastBankAccount] = useState();
  // const [lastCashAccount, setLastCashAccount] = useState();
  // const [LoadingLastAccount, setLoadingLastAccount] = useState(true);
  const { data: LastBankCashAccounts, isFetching: LoadingLastAccount } = useGetLastUsedBankOrCashAccountQuery({
    transactiontypecd: 'receipt',
  });
  const { LastBankAccount, lastCashAccount } = LastBankCashAccounts || {};

  const fetchLastBankVoucher = useCallback(async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(getLastUsedBankOrCashAccount, {
          transactiontypecd: 'receipt',
          rowfrom: 0,
          limitno: 1,
          columnname: 'transactionid',
          ordertype: 'desc',
          searchmode: 1,
          searcharray: JSON.stringify([{ bank: '' }]),
        })
      );

      const lastPaymentMethod = response?.data?.getLastUsedBankOrCashAccount?.paymentmethodlastused;

      setState((prev) => ({
        ...prev,
        method: lastPaymentMethod === 'Cash' ? 'CashReceipt' : 'BankReceipt',
        receivedTo:
          lastPaymentMethod === 'Cash'
            ? { label: 'Cash A/c', value: 3, AccountTypeFlag: '' }
            : { label: 'Bank A/c', value: 39, AccountTypeFlag: '' },
        errorStatus: {
          ...prev.errorStatus,
          method: false,
          receivedTo: false,
        },
        errorFields: {
          ...prev.errorFields,
          method: '',
          receivedTo: '',
        },
      }));
    } catch (error) {
      console.error(error);
    }
  }, []); // No dependencies → stable function

useEffect(() => {
  fetchLastBankVoucher();
}, [fetchLastBankVoucher]);


  useEffect(() => {
    if (lastCashAccount && method === 'CashReceipt' && !params.id) {
      let acc = AllAccountsListing.find((elem) => elem.value == lastCashAccount);
      setState((prev) => ({
        ...prev,
        receivedTo: acc?.label
          ? {
              label: acc?.label?.trim(),
              value: acc?.value,
              AccountTypeFlag: '',
            }
          : {
              label: '',
              value: '',
              AccountTypeFlag: '',
            },
        errorStatus: {
          ...prev.errorStatus,
          receivedTo: false,
        },
        errorFields: {
          ...prev.errorFields,
          receivedTo: '',
        },
      }));
    }
  }, [lastCashAccount]);

  async function getTdsDetails() {
    try {
      setBackdropOpen(true);
      const res = await API.graphql(graphqlOperation(getCompanyCodeTranslation, { codetype: '1' }));
      if (res.data.getCompanyCodeTranslation !== null) {
        let tdsArr = res?.data?.getCompanyCodeTranslation.map((element) => {
          return {
            option: `${element.codetext} (${element.codevalue}%)`,
            value: `${element.codevalue}`,
            section: element.codeorder,
          };
        });
        setTdsSection(tdsArr);
      }
    } catch (e) {
      console.log(e, 'error');
    } finally {
      setBackdropOpen(false);
    }
  }
  const getEntryData = useCallback(async (data) => {
    try {
      setPaymentFlag(true);
      const res = await API.graphql(graphqlOperation(getTransactionMaster, { transactionid: data }));
      if (!res.data.getTransactionMaster) return showWarningSnackbar('No data found for this voucher !');
      setEntryData(res.data?.getTransactionMaster[0]);
      setisVoucherEditable(
        res.data?.getTransactionMaster?.[0]?.isvouchereditable === 1 || res.data?.getTransactionMaster?.[0]?.serialnumber === ''
      );
      let details = await API.graphql(
        graphqlOperation(getReceiptDetails, {
          transactionid: data,
          financialyearid: userPreferenceAndFY?.financialYear?.financialyearid,
        })
      );
      let accTransaction = res.data.getTransactionMaster[0].relatedtransactiondetails?.find((elem) => elem.transactiontypecd == 'Credit');
      let acid = accTransaction?.accountid;
      let response = await API.graphql(
        graphqlOperation(getTransactionRelationWithAccountID, {
          accountid: acid,
        })
      );
      setState((prev) => ({
        ...prev,
        TAN: details?.data?.getReceiptDetails?.[0]?.tan,
        PartyName: details?.data?.getReceiptDetails?.[0]?.partyname,
      }));
      setInitialState((prev) => ({
        ...prev,
        TAN: details?.data?.getReceiptDetails?.[0]?.tan,
        PartyName: details?.data?.getReceiptDetails?.[0]?.partyname,
      }));
    } catch (e) {
      console.log(e, 'error');
      setBackdropOpen(false);
    }
  }, []);

  const [amountsFromTable, setamountsFromTable] = useState({
    tdsAmount: 0,
    receivableAmount: 0,
  });

  function displayReceiptDetails() {
    try {
      setBackdropOpen(true);
      setVouchNo(entryData.vouchernumber);
      getTdsTransaction(entryData.transactionid);
      listTransactionRelationDetails(entryData.transactionid);
      setCurrentBankRefNo(entryData.bankreferencenumber);
      setEntryStamp(entryData.enteredtimestamp);
      let from = new Date(Number(entryData.entrydate) * 1000);
      let fromyy = from.getFullYear();
      let frommm = from.getMonth() + 1;
      let fromdd = from.getDate();

      if (fromdd < 10) fromdd = '0' + fromdd;
      if (frommm < 10) frommm = '0' + frommm;

      const fromDate = fromyy + '-' + frommm + '-' + fromdd;
      let tdsAmount = 0;
      const remark = entryData.comments.split('**');
      let pay = '';
      pay = entryData.transactiontypecd;
      setEntries(entryData.relatedtransactiondetails);
      setState((prev) => ({
        ...prev,
        vouchernumber: entryData.vouchernumber,
        seriesVouchers: {
          label: entryData?.serialnumber,
          value: entryData?.serialnumber,
        },
        date: fromDate,
        remarks: entryData.comments.replace('**', '\n'),
        bankRefNo: entryData.bankreferencenumber,
        method: pay,
        Towards: entryData.towards || '',
      }));
      setInitialState((prev) => ({
        ...prev,
        vouchernumber: entryData.vouchernumber,
        seriesVouchers: {
          label: entryData?.serialnumber,
          value: entryData?.serialnumber,
        },
        date: fromDate,
        remarks: entryData.comments.replace('**', '\n'),
        bankRefNo: entryData.bankreferencenumber,
        method: pay,
        Towards: entryData.towards || '',
      }));
      console.log({ serialNos });
      setSerialNos((prev) => [
        ...prev.filter((item) => item.value !== entryData?.serialnumber),
        {
          label: entryData?.vouchernumber,
          value: entryData?.vouchernumber,
        },
      ]);

      if (entryData.relatedtransactiontdsdetails?.length > 0) {
        entryData.relatedtransactiontdsdetails.map((ele, ind) => {
          tdsAmount = ele.tdsamount;
          setState((prev) => ({
            ...prev,
            tdsAmount: `${ele.tdsamount}`,
            tdsApplicable: `${ele.tdsapplicablecd}`,
            TDSPercentage: ele.tdspercentage,
            TDSManual: ele.tdsmanual,
          }));
          setInitialState((prev) => ({
            ...prev,
            tdsAmount: `${ele.tdsamount}`,
            tdsApplicable: `${ele.tdsapplicablecd}`,
            TDSPercentage: ele.tdspercentage,
            TDSManual: ele.tdsmanual,
          }));
          setamountsFromTable((prev) => ({ ...prev, tdsAmount: tdsAmount }));
        });
      }

      if (entryData.relatedtransactionattachment?.length > 0) {
        let items = [];
        entryData.relatedtransactionattachment.map((item, ind) => {
          items.push({
            slNo: '',
            documentname: item.documentname,
            imagename: item.attachmentname,
            action: '',
            imageurl: item.attachmenturl,
            attachmentid: item.attachmentid,
            transactionid: item?.transactionid,
            type: item?.type,
          });
        });
        setAttachments(items);
        setCurrentDocuments(items);
        setInitialAttachments(items);
      }
      let amounts = 0;
      if (entryData.relatedtransactiondetails?.length > 0) {
        let fromAccount = { label: '', value: '' };
        let toAccount = { label: '', value: '' };
        pay = entryData.transactiontypecd;
        entryData.relatedtransactiondetails.map((ele) => {
          if (ele.accountid != 22) {
            if (ele.debitamount == 0 && ele.transactiontypecd == 'Credit') {
              AllAccountsListing.map((subele) => {
                if (ele.accountid == subele.value) {
                  toAccount = {
                    label: subele.label,
                    value: subele.value,
                    AccountTypeFlag: subele.AccountTypeFlag,
                  };
                }
              });
              setAccountID(toAccount.value);
              amounts = ele.creditamount;
            } else {
              if (pay === 'CashReceipt') {
                AllAccountsListing.map((subele) => {
                  if (ele.accountid == subele.value) {
                    fromAccount = {
                      label: subele.label,
                      value: subele.value,
                      AccountTypeFlag: subele.AccountTypeFlag,
                    };
                  }
                });
                setCashAccountObj(fromAccount);
              } else {
                AllAccountsListing.map((subele) => {
                  if (ele.accountid == subele.value) {
                    fromAccount = {
                      label: subele.label,
                      value: subele.value,
                      AccountTypeFlag: subele.AccountTypeFlag,
                    };
                  }
                });
                setBankAccountObj(fromAccount);
              }
            }
          }
        });

        getTransactions(toAccount.value, entryData.vouchernumber);
        setState((prev) => ({
          ...prev,
          receivedTo: fromAccount,
          receivedFrom: toAccount,
          receivableAmount: `${amounts}`,
        }));
        setInitialState((prev) => ({
          ...prev,
          receivedTo: fromAccount,
          receivedFrom: toAccount,
          receivableAmount: `${amounts}`,
        }));
        setamountsFromTable((prev) => ({
          ...prev,
          receivedFrom: toAccount,
          receivedTo: fromAccount,
        }));
      }

      setamountsFromTable((prev) => ({ ...prev, receivableAmount: amounts }));
    } catch (e) {
      console.log(e, 'error');
      setBackdropOpen(false);
    } finally {
      // setBackdropOpen(false)
    }
  }

  const [lastInvoiceDate, setLastInvoiceDate] = useState('');
  const [firstInvoiceDate, setFirstInvoiceDate] = useState('');
  const [nextInvoiceDate, setNextInvoiceDate] = useState('');
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [openingBalanceDate, setOpeningBalanceDate] = useState();

  const userPreferenceAndFYDate = useSelector((state) => state.userPrefrenceandReducer);

  function startDateMian(startYearDate) {
    const formattedDate = dayjs.unix(startYearDate).format('YYYY-MM-DD');
    return `${formattedDate}`;
  }

  async function getMinandMax() {
    try {
      const res = await API.graphql(
        graphqlOperation(getMinMaxInvoiceDate, {
          invoicetypecd: 'Receipt',
          invoiceid: params?.id && !isNaN(params?.id) ? params?.id : 0,
        })
      );
      setOpeningBalanceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
      if (res?.data?.getMinMaxInvoiceDate !== null) {
        if (res?.data?.getMinMaxInvoiceDate?.previnvoicedate !== null) {
          setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.previnvoicedate);
        } else {
          setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
          if (params?.id === '' || isNaN(params?.id)) {
            if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
              setState((prev) => ({
                ...prev,
                date: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
              }));
              setInitialState((prev) => ({
                ...prev,
                date: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
              }));
            } else {
              if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
                setState((prev) => ({
                  ...prev,
                  date: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                }));
                setInitialState((prev) => ({
                  ...prev,
                  date: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                }));
              } else {
                const firstDate = startDateMian(userPreferenceAndFY.financialYear.startdate);
                setState((prev) => ({
                  ...prev,
                  date: firstDate,
                }));
                setInitialState((prev) => ({
                  ...prev,
                  date: firstDate,
                }));
              }
            }
          }
        }
        if (res?.data?.getMinMaxInvoiceDate?.nextinvoicedate !== null) {
          setNextInvoiceDate(res?.data?.getMinMaxInvoiceDate?.nextinvoicedate);
        }
        if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
          setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.latestinvoicedate);
          if (params?.id === '' || isNaN(params?.id)) {
            if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
              setState((prev) => ({
                ...prev,
                date: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
              }));
              setInitialState((prev) => ({
                ...prev,
                date: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
              }));
            } else {
              if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
                setState((prev) => ({
                  ...prev,
                  date: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                }));
                setInitialState((prev) => ({
                  ...prev,
                  date: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                }));
              }
            }
          }
        } else {
          setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const { data: recetMinMAx, isLoading } = useGetMinMaxInvoiceDateQuery({
    invoicetypecd: 'Receipt',
    invoiceid: params?.id && !isNaN(params?.id) ? params?.id : 0,
  });


    useEffect(() =>{
        if(recetMinMAx)
        setOpeningBalanceDate(recetMinMAx.openingBalanceDate);
    },[!isLoading])

  const openingDate = useMemo(() => {
    const date = savedPostingDate ? moment(savedPostingDate * 1000).format('YYYY-MM-DD') : openingBalanceDate;

    const dateValue = recetMinMAx?.getMinMaxInvoiceDate?.openingbalancedate;

    return dateValue && dateValue !== 'null' ? dateValue : date || startDateMian(userPreferenceAndFY?.financialYear?.startdate);
  }, [savedPostingDate, openingBalanceDate, recetMinMAx, userPreferenceAndFY, startDateMian]);

  function fetchOpeningDate() {
    try {
      const openingBalanceDate = recetMinMAx?.openingBalanceDate ?? null;
      const date = savedPostingDate ? moment(savedPostingDate * 1000).format('YYYY-MM-DD') : openingBalanceDate || '';

      setState((prev) => ({ ...prev, date }));
      setInitialState((prev) => ({ ...prev, date }));
    } catch (error) {
      console.error('Error fetching opening date:', error);
    }
  }

  useEffect(() => {
    if (params?.id) {
      if (entryData?.transactionid) {
        fetchOpeningDate();
      }
    } else {
      fetchOpeningDate();
    }
  }, [savedPostingDate, isLoading]);

  function handleReceiptDateChanges(value) {
    const startDate = openingBalanceDate 
          ? moment(openingBalanceDate, 'YYYY-MM-DD', true).isValid() 
            ? moment(openingBalanceDate, 'YYYY-MM-DD')
            : moment.unix(userPreferenceAndFY.financialYear.startdate)
          : moment.unix(userPreferenceAndFY?.financialYear?.startdate);
    console.log(startDate, '****startDate');

    const endDate = moment.unix(userPreferece.financialYear.enddate);
    console.log(endDate, '****enddate');

    const inputDate = moment(value, 'YYYY-MM-DD', true);
    console.log(inputDate, '****inputDate');
    const errorStartDate = startDate.format(DEFAULT_DATE_FORMAT);
    const errorEndDate = endDate.format(DEFAULT_DATE_FORMAT);

    setState((prev) => ({
      ...prev,
      date: value,
    }));

    if (value === '') {
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          date: true,
        },
        errorFields: {
          ...prev.errorFields,
          date: 'Please select Payment Date',
        },
      }));
      return;
    }

    if (!inputDate.isValid()) {
      return;
    }

    if (!inputDate.isBetween(startDate, endDate, undefined, '[]')) {
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          date: true,
        },
        errorFields: {
          ...prev.errorFields,
          date: `Date must be within ${errorStartDate} and ${errorEndDate}.`,
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          date: false,
        },
        errorFields: {
          ...prev.errorFields,
          date: '',
        },
      }));
    }
  }

  async function getFY() {
    try {
      setStartDate(userPreferenceAndFYDate.financialYear.startdate);
      setEndDate(userPreferenceAndFYDate.financialYear.enddate);
    } catch (error) {
      console.log('Error', error);
    }
  }
  useEffect(() => {
    // getMinandMax();
    getFY();
  }, []);

  async function getTdsTransaction(data) {
    try {
      setBackdropOpen(true);
      const res = await API.graphql(graphqlOperation(getTransactionTDSDetails, { transactionid: data }));
      if (res.data.getTransactionTDSDetails !== null) {
        setTdsID(res.data.getTransactionTDSDetails.transactionid);
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  async function listTransactionRelationDetails(tID) {
    try {
      let objID = '';
      let paymentFlag = false;
      const res = await API.graphql(graphqlOperation(listTransactionRelation));
      console.log(res.data, '////');
      res.data.listTransactionRelation.map((ele) => {
        if (ele.transactionid == tID) {
          objID = ele.objectid;
          paymentFlag = true;
        }
      });
      // setCurrentPaymentFlag(paymentFlag);
      getCrediteNoteDetails(objID);
      getentryData(objID);
    } catch (error) {
      console.log('error', error);
    }
  }
  async function getentryData(objID) {
    try {
      const res = await API.graphql(graphqlOperation(getInvoiceMaster, { InvoiceID: objID }));
      setInvoiceData(res.data.getInvoiceMaster);
    } catch (error) {
      console.log('error', error);
    }
  }
  async function getCrediteNoteDetails(objID) {
    try {
      const res = await API.graphql(graphqlOperation(getCrDrNoteMaster, { CrDrNoteID: objID }));
      setCrDrDetails(res.data.getCrDrNoteMaster);
    } catch (error) {
      console.log('error', error);
    }
  }
  const [FromBalanceAmountv2, setFromBalanceAmountv2] = useState({
    balance: 0,
    balanceSign: 1,
  });
  async function getFromAccountBalanceAmount(data) {
    try {
      setBackdropOpen(true);
      const accountBalance = await API.graphql(graphqlOperation(getAccountBalance, { accountid: Number(data) }));

      if (accountBalance.data.getAccountBalance !== null) {
        let balance = accountBalance.data.getAccountBalance?.[0].accountbalance;
        setFromBalanceAmount(balance || 0);
        setFromBalanceAmountv2({
          balance: balance || 0,
          balanceSign: accountBalance.data.getAccountBalance?.[0].balancesign,
        });
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setBackdropOpen(false);
    }
  }
  const [ToBalanceAmountv2, setToBalanceAmountv2] = useState({
    balance: 0,
    balanceSign: 1,
  });
  async function getToAccountBalanceAmount(data) {
    try {
      setBackdropOpen(true);
      const accountBalance = await API.graphql(graphqlOperation(getAccountBalance, { accountid: Number(data) }));
      if (accountBalance.data.getAccountBalance !== null) {
        let balance = accountBalance.data.getAccountBalance[0]?.accountbalance;
        setToBalanceAmount(balance);
        setToBalanceAmountv2({
          balance,
          balanceSign: accountBalance.data.getAccountBalance[0]?.balancesign,
        });
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setBackdropOpen(false);
    }
  }
  async function getAccountName() {
    let accName = {
      label: '',
      value: '',
      AccountTypeFlag: '',
    };
    AllAccountsListing.map((ele) => {
      if (location?.state?.name?.toUpperCase()?.trim() === ele?.label?.toUpperCase()?.trim()) {
        accName = {
          label: ele.label,
          value: ele.value,
          AccountTypeFlag: ele.AccountTypeFlag,
        };
      }
    });

    setState((prev) => ({
      ...prev,
      paidTo: accName,
    }));
    setInitialState((prev) => ({
      ...prev,
      paidTo: accName,
    }));
  }
  const {
    data: AccountMasterList,
    isLoading: isAccountMasterLoading,
    isError: AccountMasterError,
    refetch: refetchAccountMaster,
  } = useListAccountMasterv2Query(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (!AccountMasterList) {
      refetchAccountMaster();
    }
  }, [AccountMasterList]);

  let AllAccountsListing = useMemo(() => {
    if (!AccountMasterList) return [];
    let allAccount = [];
    console.log({ AccountMasterList });
    AccountMasterList.map((item) => {
      let groupName = item.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
      let AccountGroupID = item.accountgroupid;
      if (item.is_active === 1 && item.accountsid !== 23 && item.accountsid !== 24) {
        allAccount.push({
          label: `${item.accountname} `,
          value: item.accountsid,
          groupName,
          AccountGroupID,
          TDSSection: item.tdssection,
          TDSPercentage: item.tdspercentage,
          AccountTypeFlag: item.accounttypeflag,
          path: item.path,
        });
      }
    });
    return allAccount;
  }, [AccountMasterList]);

  let BankAccountsListing = useMemo(() => {
    if (!AccountMasterList) return [];
    let bankAccAr = [];
    AccountMasterList.map((item) => {
      let groupName = item.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
      let AccountGroupID = item.accountgroupid;
      if ((item.accountgroupid === 17 || item.accountgroupid === 29) && item.is_active === 1) {
        bankAccAr.push({
          label: `${item.accountname} `,
          value: item.accountsid,
          groupName,
          AccountGroupID,
          AccountTypeFlag: item.accounttypeflag,
        });
      }
    });
    return bankAccAr;
  }, [AccountMasterList]);
  let CashAccountsListing = useMemo(() => {
    if (!AccountMasterList) return [];
    let cashAccArr = [];
    AccountMasterList.map((item) => {
      let groupName = item.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
      let AccountGroupID = item.accountgroupid;
      if (item.accountgroupid === 16 && item.is_active === 1) {
        cashAccArr.push({
          label: `${item.accountname}`,
          value: item.accountsid,
          groupName,
          AccountGroupID,
          AccountTypeFlag: item.accounttypeflag,
        });
      }
    });
    return cashAccArr;
  }, [AccountMasterList]);
  async function getAccountMasterData() {
    try {
      setBackdropOpen(true);
      let cashAccArr = [];
      let bankAccAr = [];
      let allAccount = [];
      dispatch(listAccountMasterv2Api.util.invalidateTags(['listAccountMaster']));
      // const res = await API.graphql(
      //   graphqlOperation(listAccountMasterv2Custom)
      // );
      // if (res.data.listAccountMasterv2 !== null) {
      //   res.data.listAccountMasterv2.map((item) => {
      //     let groupName = item.accountgroupname.replace(
      //       /([a-z])([A-Z])/g,
      //       "$1 $2"
      //     )?.trim();
      //     let AccountGroupID = item.accountgroupid;
      //     if (
      //       item.is_active === 1 &&
      //       item.accountsid !== 23 &&
      //       item.accountsid !== 24
      //     ) {
      //       allAccount.push({
      //         label: `${item.accountname} `,
      //         value: item.accountsid,
      //         groupName,
      //         AccountGroupID,
      //         TDSSection: item.tdssection,
      //         TDSPercentage: item.tdspercentage,
      //         AccountTypeFlag: item.accounttypeflag,
      //       });
      //     }
      //     if (item.accountgroupid === 16 && item.is_active === 1) {
      //       cashAccArr.push({
      //         label: `${item.accountname}`,
      //         value: item.accountsid,
      //         groupName,
      //         AccountGroupID,
      //         AccountTypeFlag: item.accounttypeflag,
      //       });
      //     }
      //     if (
      //       (item.accountgroupid === 17 || item.accountgroupid === 29) &&
      //       item.is_active === 1
      //     ) {
      //       bankAccAr.push({
      //         label: `${item.accountname} `,
      //         value: item.accountsid,
      //         groupName,
      //         AccountGroupID,
      //         AccountTypeFlag: item.accounttypeflag,
      //       });
      //     }
      //   });
      //   setAccountName(allAccount);
      //   setCashAccount(cashAccArr);
      //   setBankAccount(bankAccAr);
      // }
    } catch (error) {
      console.log('error', error);
    } finally {
      setBackdropOpen(false);
    }
  }
  async function saveLinkTranSaction(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(createTransactionRelation, {
          createTransactionRelationInput: data,
        })
      );
    } catch (error) {
      console.log('error', error);
    }
  }

  const { data: generalSettings } = useListGeneralSettingQuery(
    {
      entrytypecd: 'Receipt',
      financialyearid: userPreferece?.financialYear?.financialyearid,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  console.log({ generalSettings });
  async function getItemSettings() {
    try {
      let serialNoArr = [];
      let voucherNo = '';
        let voucherSeries={label:'',value:''};
      // const res = await API.graphql(
      //   graphqlOperation(listVoucherSerialNumbers, {
      //     entrytypecd: "Receipt",
      //     // InputDate: Math.floor(new Date(todayDate).getTime() / 1000),
      //   })
      // );
      const res = { data: { listVoucherSerialNumbers: generalSettings } };

      let nextInvNo = '';
      if (res.data.listVoucherSerialNumbers.length > 0) {
        let settingsArr = res.data.listVoucherSerialNumbers?.map((ele) => {
          if (ele.expiredtimestamp == 0) {
            nextInvNo = ele.nextinvoicenumber;
            return ele;
          }
        });
        if (nextInvNo !== -1) {
          setGeneralSettingsFlag(nextInvNo);
          // const resSerialVouchers = await API.graphql(
          //   graphqlOperation(listVoucherSerialNumbers, {
          //     EntryTypeCD: "Receipt",
          //   })
          // );
          let resSerialVouchers = res;
          setActiveVouchers(resSerialVouchers.data.listVoucherSerialNumbers);
          resSerialVouchers.data.listVoucherSerialNumbers.map((ele) => {
            if (ele.serialisactive == 1) {
              serialNoArr.push({
                label: ele.prefix + ele.nextinvoicenumber + ele.suffix,
                value: ele.serialnumber,
              });
                if(ele?.lastused===1){
              voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
              voucherSeries={label:ele.prefix + ele.nextinvoicenumber + ele.suffix,value:ele?.serialnumber};
            }else{
             if (ele.serialnumber === serialNoArr?.[0]?.value) {
               voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
              voucherSeries={label:ele.prefix + ele.nextinvoicenumber + ele.suffix,value:ele?.serialnumber};
             }
            }
            }
          });
          setSerialNos(serialNoArr);
          if (!params.id) {
            setState((prev) => ({
              ...prev,
              vouchernumber: voucherNo,
            }));
            setInitialState((prev) => ({
              ...prev,
              vouchernumber: voucherNo,
            }));
            setState((prev) => ({
              ...prev,
              seriesVouchers: voucherSeries
              // {
              //   label: serialNoArr?.[0]?.label,
              //   value: serialNoArr?.[0]?.value,
              // },
            }));
            setInitialState((prev) => ({
              ...prev,
              seriesVouchers:voucherSeries
              //  {
              //   label: serialNoArr?.[0]?.label,
              //   value: serialNoArr?.[0]?.value,
              // },
            }));
          }
        } else {
          setGeneralSettingsFlag(-1);
          if (entryData.length == 0) {
            setState((prev) => ({
              ...prev,
              vouchernumber: '',
            }));
            setInitialState((prev) => ({
              ...prev,
              vouchernumber: '',
            }));
          } else {
            setState((prev) => ({
              ...prev,
              vouchernumber: entryData.VoucherNumber,
              seriesVouchers: {
                label: '',
                value: '',
              },
            }));
            setInitialState((prev) => ({
              ...prev,
              vouchernumber: entryData.VoucherNumber,
              seriesVouchers: {
                label: '',
                value: '',
              },
            }));
          }
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  async function listVoucherNos() {
    try {
      let Arr = [];
      let arr = [];
      // const res = await API.graphql(
      //   graphqlOperation(listTransactionMasterCustom)
      // );
      const res = await API.graphql(graphqlOperation(listPartyAndTransactionMastersCustomRec));
      if (res.data.listTransactionMaster.length > 0) {
        res.data.listTransactionMaster.map((ele) => {
          if (ele.transactiontypecd === 'CashReceipt' || ele.transactiontypecd === 'BankReceipt') {
            Arr.push(ele);
          }
        });
        setReceiptVoucherNos(Arr);
      }
      res.data.listPartymasters.map((ele) => {
        arr.push({ Name: ele.partylegalname, value: ele.partyid });
      });
      setPartyList(arr);
    } catch (error) {
      console.log('error', error);
    }
  }
  let url = path + `Invoices/Receipt/Ledgerx_Receipt_${state.vouchernumber}.pdf`;
  let uri = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${url}`;

  async function saveChanges(obj) {
    let receiptTransArr = [];
    try {
      const {
        vouchernumber,
        date,
        method,
        receivedFrom,
        receivedTo,
        receivableAmount,
        tds,
        tdsApplicable,
        tdsAmount,
        receivedAmount,
        bankRefNo,
        remarks,
        attachment,
        Towards,
      } = state;

      const formData = {
        vouchernumber,
        date,
        method,
        receivedFrom,
        receivedTo,
        receivableAmount,
        tdsApplicable,
        tdsAmount,
        bankRefNo,
        remarks,
        attachment,
      };

      const comments = state.remarks;
      if (formValidation(formData)) {
        setBackdropOpen(true);
        const masterData = {
          pdflink: uri,
          bankreferencenumber: bankRefNo,
          comments: comments,
          entrydate: Math.floor(new Date(date).getTime() / 1000),
          transactiontypecd: method,
          vouchercode: generalSettingsFlag == -1 ? state.vouchernumber : '',
          serialnumber: state.seriesVouchers.value,
          cancelflag: 0,
          towards: Towards || '',
        };

        const transactionCreditData = {
          accountid: receivedFrom.value,
          comments: comments,
          creditamount: Number(receivableAmount),
          debitamount: 0,
          // entryordernumber: 1,
          transactiontypecd: 'Credit',
          cancelflag: 0,
        };

        const transactionDebitData = {
          accountid: receivedTo.value,
          comments: comments,
          creditamount: 0,
          debitamount:
            tdsAmount === '' || tdsAmount === 0
              ? Number(Number(receivableAmount).toFixed(2))
              : Number((Number(receivableAmount) - Number(tdsAmount)).toFixed(2)),

          // entryordernumber: 2,
          transactiontypecd: 'Debit',
          cancelflag: 0,
        };
        receiptTransArr.push(transactionCreditData, transactionDebitData);
        let tdsData = {};

        if (state.tdsAmount) {
          tdsData = {
            tdsamount: tdsAmount === '' ? 0 : Number(tdsAmount),
            tdsapplicablecd: tdsApplicable,
            tdspercentage: state.TDSPercentage,
            tdsmanual: state.TDSManual,
          };
          const tdsDetaials = {
            accountid: 22,
            comments: comments,
            creditamount: 0,
            debitamount: tdsAmount === '' ? 0 : Number(Number(tdsAmount).toFixed(2)),
            // entryordernumber: 3,
            transactiontypecd: 'Debit',
            cancelflag: 0,
          };
          if (tdsData?.tdsamount != 0) {
            //   const resTds = await API.graphql(
            //     graphqlOperation(createTransactionTDSDetails, {
            //       createTransactionTDSDetailsInput: tdsData,
            //     })
            //   );
            receiptTransArr.push(tdsDetaials);
          }
        }

        let attachment = attachments.map((item) => {
          const attType = item.type.split('/')[1];
          const attachmentData = {
            type: attType,
            attachmentname: item.imagename,
            attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${item.imagename}`,
            documentname: item.documentname,
          };
          return attachmentData;
          // addAttachmets(attachmentData);
        });

        let sumOfLinkedTransaction = 0;
        let linkTransData = [];
        let imagesArray;
        console.log({ state, vouchers });
        if (vouchers.length > 0) {
          vouchers?.map((ele) => {
            console.log(ele);
            if (ele.LinkedAmount > 0) {
              linkTransData.push({
                linkedamount: ele.LinkedAmount,
                transactiontypecd: method,
                objectattribute: ele.ObjectAttribute,
                objectid: ele.ObjectID,
                isdirect: ele.IsDirect,
                objecttype: ele.ObjectType,
                accountid: receivedFrom.value,
                paymentvouchernumber: state.vouchernumber,
                expiredtimestamp: 0,
              });
            }
            // saveLinkTranSaction(linkTransData);
            sumOfLinkedTransaction += Number(ele.LinkedAmount);
          });
        }

        if (sumOfLinkedTransaction > receivableAmount) {
          return showWarningSnackbar('Linked Amount is greater than Paid To Amount');
        }
        let result = await baseQueryv2({
          body: createTransactionWithSpecificTimev2,
          variables: {
            createTransactionWithSpecificTimeInput: {
              transactionmaster: [masterData],
              transactiondetails: receiptTransArr,
              transactionattachment: attachment,
              transactiontdsdetails: tdsData?.tdsamount > 0 ? [tdsData] : [],
              transactionrelation: linkTransData,
              mode: 1,
              transactiontcsdetails: [],
            },
          },
        });
        if (result.data?.statuscode == 'Success') {
          createPdf({
            path: url,
            type: 'receipt',
            transactionid: result.data.transactionid,
          });
          // let responses = attachments.map((element) => {
          //   if (element.file) {
          //     return uploadToServer(
          //       element.file,
          //       element.imagename.replace("${id}", result.data.transactionid),
          //       element.type
          //     );
          //   }
          // });

          let responses = await Promise.all(
            attachments.map(async (element) => {
              if (element.file) {
                try {
                  console.log(`Uploading file: ${element.imagename}`);
                  const uploadResponse = await uploadToServer(
                    element.file,
                    element.imagename.replace('${id}', result.data.transactionid),
                    element.type
                  );
                  return { success: true, file: element.imagename, response: uploadResponse };
                } catch (error) {
                  const extracted = element.documentname;
                  return { success: false, file: element.imagename, extracted, error };
                }
              }
            })
          );

          imagesArray = responses.map((item) => item.extracted).filter(Boolean);

          let nweAttachments;
          let imageUploadArray;

          if (imagesArray.length > 0) {
            const res = await API.graphql(graphqlOperation(getTransactionMasterV2, { transactionid: result.data.transactionid }));

            nweAttachments = res.data?.getTransactionMaster[0]?.relatedtransactionattachment;
            imageUploadArray = nweAttachments.filter((attachment) => imagesArray?.some((upload) => upload === attachment.documentname));

            const updatedImageArray = imageUploadArray.map((item) => ({
              attachmentid: item.attachmentid,
              transactionid: item.transactionid,
              expiredtimestamp: Math.floor(Date.now() / 10000),
              attachmentname: item.attachmentname,
              attachmenturl: item.attachmenturl,
              documentname: item.documentname,
              type: item.type,
            }));
            const updatedResponse = await API.graphql(
              graphqlOperation(createTransactionAttachment, {
                createTransactionAttachmentInput: updatedImageArray,
              })
            );
          }

          let response = await Promise.all(responses);
          dispatch(setNavigationBlocked(false));
          showSuccessSnackbar('Receipt Entry created successfully');
          dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listVoucherSettings', id: 'Payment' }]));
          dispatch(VoucherSettingsApi.util.invalidateTags(['listUsedVoucherSettings']));
          dispatch(dashboardApi.util.invalidateTags(['dashboard',"bizview"]));
          dispatch(paymentApi.util.invalidateTags([{ type: 'lastUsedAccount', id: 'receipt' }]));
        } else {
          return showWarningSnackbar('Something went wrong !');
        }
        localStorage.setItem('saveEvent', true);
        setBackdropOpen(false);
        if (obj.print) {
          handlePrint(true);
          navigate('/receipts');
        } else if (obj.new === true) {
          // getTransactions(state.receivedFrom.value,null,params?.invoiceNumber)
          getToAccountBalanceAmount(`${state.receivedTo.value}`);
          setState((prev) => ({
            ...prev,
            ...initialState,
            receivedTo: prev.receivedTo,
            method: prev.method,
          }));
          setvouchers([]);
          setAttachments([]);
          if (params.partyID) {
            getTransactions(params.partyID);
          }
        } else if (obj.new == false) {
          if (imagesArray.length === 0) {
            onSaveComplete();
          } else {
            setSummaryData({
              open: true,
              description: `${imagesArray.length == 1 ? 'Image' : 'Images'} cannot be uploaded`,
              lists: [...imagesArray],
              title: `${imagesArray.length == 1 ? 'Image' : 'Some images'} cannot be uploaded !`,
            });
          }
        } else {
          setState(initialState);
          // window.location.reload();
        }
        invalidateAllVoucherSerialNumbers();
      } else {
        window.scrollTo(0, 0);
      }
    } catch (error) {
      console.log('error', error);
      showErrorSnackbar(error.message);
      setBackdropOpen(false);
    } finally {
      setBackdropOpen(false);
    }
  }
  let userData = useSelector((state) => state.userDetailsReducer?.userDetails);

  function handlePrint(status, voucherNo) {
    let dataForPrint = {
      companyDetails,
      state,
      userData,
      voucherNo,
      type: 'Receipt',
      vouchers: vouchers.filter((data) => data.LinkedAmount > 0),
    };
    const html1 = ReceiptPrint(dataForPrint);

    if (status === true) {
      return html1;
    } else {
      printJS({
        printable: html1,
        type: 'raw-html',
        documentTitle: 'Receipt',
      });
    }
  }

  async function saveEditChanges({ toCancel = 0, CancelRemark = '' } = {}) {
    let receiptTransArr = [];
    try {
      const {
        vouchernumber,
        date,
        method,
        receivedFrom,
        receivedTo,
        receivableAmount,
        tds,
        tdsApplicable,
        tdsAmount,
        receivedAmount,
        bankRefNo,
        remarks,
        attachment,
        Towards,
      } = state;

      const formData = {
        vouchernumber,
        date,
        method,
        receivedFrom,
        receivedTo,
        receivableAmount,
        tdsApplicable,
        tdsAmount,
        receivedAmount,
        bankRefNo,
        remarks,
        attachment,
      };
      if (formValidation(formData)) {
        setBackdropOpen(true);
        const comments = state.remarks;
        const entrydate = Math.floor(new Date(date).getTime() / 1000);
        const masterData = {
          pdflink: uri,
          transactionid: entryData.transactionid,
          bankreferencenumber: bankRefNo,
          entrydate: entrydate,
          comments: comments,
          vouchercode: state.vouchernumber,
          transactiontypecd: state.method,
          serialnumber: state.seriesVouchers.value,
          cancelflag: toCancel ?? 0,
          cancelremark: CancelRemark ?? '',
          towards: Towards || '',
        };

        const transactionCreditData = {
          accountid: receivedFrom.value,
          comments: comments,
          creditamount: Number(receivableAmount),
          debitamount: 0,
          // entryordernumber: 1,
          transactionid: entryData.transactionid,
          enteredtimestamp: entrydate,
          transactiontypecd: 'Credit',
          cancelflag: toCancel ?? 0,
        };

        const transactionDebitData = {
          accountid: receivedTo.value,
          comments: comments,
          creditamount: 0,
          debitamount: tdsAmount === '' || tdsAmount === 0 ? Number(receivableAmount) : Number(receivableAmount) - Number(tdsAmount),
          // entryordernumber: 2,
          transactionid: entryData.transactionid,
          enteredtimestamp: entrydate,
          transactiontypecd: 'Debit',
          cancelflag: toCancel ?? 0,
        };

        receiptTransArr.push(transactionCreditData, transactionDebitData);
        if (state.tdsAmount) {
          const tdsDetaials = {
            accountid: 22,
            comments: comments,
            creditamount: 0,
            debitamount: tdsAmount == '' ? 0 : Number(tdsAmount),
            // entryordernumber: 3,
            transactionid: entryData.transactionid,
            enteredtimestamp: entrydate,
            transactiontypecd: 'Debit',
            cancelflag: toCancel ?? 0,
          };
          receiptTransArr.push(tdsDetaials);
        }

        let tdsData = {};
        if (state.tdsAmount) {
          if (tdsID !== '') {
            tdsData = {
              transactionid: entryData.transactionid,
              tdsamount: !state.tdsAmount || tdsAmount === '' ? 0 : Number(tdsAmount),
              tdsapplicablecd: state.tdsAmount ? tdsApplicable : '',
              tdspercentage: state.TDSPercentage,
              tdsmanual: state.TDSManual,
            };
          } else {
            tdsData = {
              tdsamount: tdsAmount === '' ? 0 : Number(tdsAmount),
              tdsapplicablecd: tdsApplicable,
              transactionid: entryData.transactionid,
              tdspercentage: state.TDSPercentage,
              tdsmanual: state.TDSManual,
            };
          }
        }

        let attachment = attachments.map((item) => {
          const attachmentData = {
            attachmentid: typeof item.attachmentid === 'string' ? 0 : item.attachmentid,
            attachmentname: item.imagename,
            documentname: item.documentname,
            attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${item.imagename}`,
            transactionid: entryData.transactionid,
            type: item.type,
            file: item.file ?? null,
          };
          return attachmentData;
        });

        let linkTransData = [];
        let sumOfLinkedTransaction = 0;
        if (vouchers.length > 0) {
          vouchers?.map((ele) => {
            if (ele.LinkedAmount || ele.PreviousLinkedAmount) {
              linkTransData.push({
                linkedamount: ele.LinkedAmount,
                transactiontypecd: method,
                objectattribute: ele.ObjectAttribute,
                objectid: ele.ObjectID,
                isdirect: ele.IsDirect,
                objecttype: ele.ObjectType,
                transactionid: entryData?.transactionid,
                accountid: receivedFrom.value,
                paymentvouchernumber: state.vouchernumber,
                expiredtimestamp: ele.LinkedAmount > 0 ? 0 : dayjs().unix(),
              });
            }
            sumOfLinkedTransaction += Number(ele.LinkedAmount);
          });
        }
        if (sumOfLinkedTransaction > receivableAmount) {
          return showWarningSnackbar('Linked Amount is greater than Receivable Amount');
        }
        if (linkTransData.length == 0 && LinkedVouchers.length > 0) {
          linkTransData = LinkedVouchers.map((ele) => {
            return {
              linkedamount: ele.LinkedAmount,
              transactiontypecd: ele.TransactionTypeCD,
              objectattribute: ele?.ObjectAttribute,
              objectid: ele.ObjectID,
              isdirect: ele.IsDirect,
              objecttype: ele.ObjectType,
              accountid: amountsFromTable?.receivedFrom?.value,
              paymentvouchernumber: state.vouchernumber,
              transactionid: entryData?.transactionid,
              expiredtimestamp: dayjs().unix(),
            };
          });
        }
        localStorage.removeItem('ReceiptTransactionID');
        localStorage.removeItem('ReceiptViewMode');

        localStorage.setItem('updateEvent', true);

        let result = await baseQuery({
          body: createTransactionWithSpecificTimev2,
          variables: {
            createTransactionWithSpecificTimeInput: {
              transactionmaster: [masterData],
              transactiondetails: receiptTransArr,
              transactionattachment: attachment,
              transactiontdsdetails: tdsData?.tdsamount ? tdsData : [],
              transactionrelation: linkTransData,
              mode: 0,
              transactiontcsdetails: [],
            },
          },
        });
        if (result.data?.statuscode === 'Success') {
          createPdf({
            path: url,
            type: 'receipt',
            transactionid: result.data.transactionid,
          });

          let failedUploads = [];

          let responses = await Promise.all(
            attachment.map(async (element) => {
              if (element.file) {
                try {
                  console.log(`Uploading file: ${element.attachmentname}`);
                  await uploadToServer(element.file, element.attachmentname.replace('${id}', result.data.transactionid), element.type);
                  console.log(`Successfully uploaded: ${element.attachmentname}`);
                } catch (error) {
                  console.error(`Error uploading: ${element.attachmentname}`, error);
                  const extracted = element.documentname;
                  failedUploads.push(extracted);
                }
              }
            })
          );

          if (failedUploads.length > 0) {
            const res = await API.graphql(graphqlOperation(getTransactionMasterV2, { transactionid: result.data.transactionid }));
            let nweAttachments;
            let imageUploadArray;
            nweAttachments = res.data?.getTransactionMaster[0]?.relatedtransactionattachment;
            imageUploadArray = nweAttachments.filter((attachment) => failedUploads?.some((upload) => upload === attachment.documentname));

            const updatedImageArray = imageUploadArray.map((item) => ({
              attachmentid: item.attachmentid,
              transactionid: item.transactionid,
              expiredtimestamp: Math.floor(Date.now() / 10000),
              attachmentname: item.attachmentname,
              attachmenturl: item.attachmenturl,
              documentname: item.documentname,
              type: item.type,
            }));

            const updatedResponse = await API.graphql(
              graphqlOperation(createTransactionAttachment, {
                createTransactionAttachmentInput: updatedImageArray,
              })
            );
            setSummaryData({
              open: true,
              description: `${failedUploads.length == 1 ? 'Image' : 'Images'} cannot be uploaded`,
              lists: [...failedUploads],
              title: `${failedUploads.length == 1 ? 'Image' : 'Some images'} cannot be uploaded !`,
            });
          }

          // let responses = attachment.map((element) => {
          //   if (element.file) {
          //     return uploadToServer(
          //       element.file,
          //       element.attachmentname.replace(
          //         "${id}",
          //         result.data.transactionid
          //       ),
          //       element.type
          //     );
          //   }
          // });
          else {
            dispatch(setNavigationBlocked(false));
            navigate('/receipts', { force: true });
          }

          let response = await Promise.all(responses);
          dispatch(setNavigationBlocked(false));

          toCancel
            ? showSuccessSnackbar('Receipt Entry Cancelled successfully')
            : showSuccessSnackbar('Receipt Entry Updated successfully');
          // showSuccessSnackbar("Receipt Entry Updated successfully");
          // navigate("/receipts");
          dispatch(dashboardApi.util.invalidateTags(['dashboard',"bizview"]));
          dispatch(paymentApi.util.invalidateTags([{ type: 'lastUsedAccount', id: 'receipt' }]));
        } else {
          showErrorSnackbar('Something went wrong !');
        }
        setBackdropOpen(false);
      } else {
        window.scrollTo(0, 0);
      }
    } catch (error) {
      showErrorSnackbar(error.message);
      console.log('error', error);
      setBackdropOpen(false);
    } finally {
      setBackdropOpen(false);
    }
  }
  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };
    let feildsErrors = [];
    Object.keys(data).map((itemKey) => {
      if (itemKey === 'date') {
        const startDate = openingBalanceDate 
      ? moment(openingBalanceDate, 'YYYY-MM-DD', true).isValid() 
        ? moment(openingBalanceDate, 'YYYY-MM-DD')
        : moment.unix(userPreferenceAndFY.financialYear.startdate)
      : moment.unix(userPreferenceAndFY?.financialYear?.startdate);
        const endDate = moment.unix(userPreferece.financialYear.enddate);
        const errorStartDate = startDate.format(DEFAULT_DATE_FORMAT);
        const errorEndDate = endDate.format(DEFAULT_DATE_FORMAT);
        if (!moment(data[itemKey]).isBetween(startDate, endDate, undefined, '[]')) {
          obj.errorStatus.date = true;
          obj.errorFields.date = `Date must be within ${errorStartDate} and ${errorEndDate}.`;
          document.getElementById('paymentDate').focus();
          isvalid = false;
        }
      }
      if (itemKey === 'receivedFrom') {
        if (data[itemKey]?.value?.length <= 0 && paymentFlag == true) {
          isvalid = false;
          obj.errorFields.receivedFrom = 'Received From Field is required';
          feildsErrors.push(obj.errorFields.receivedFrom);
          obj.errorStatus.receivedFrom = true;
          document.getElementById('receivedFrom').focus();
        } else if (obj.receivedFrom.value === obj.receivedTo.value) {
          isvalid = false;
          obj.errorFields.receivedFrom = 'Received From and Received To should be different';
          obj.errorStatus.receivedFrom = true;
          document.getElementById('receivedFrom').focus();
        } else {
          // isvalid=true;
          obj.errorFields.receivedFrom = '';
          obj.errorStatus.receivedFrom = false;
        }
      }
      if (itemKey === 'receivedTo') {
        if (data[itemKey].value?.length <= 0) {
          isvalid = false;
          obj.errorFields.receivedTo = 'Received To Field is required';
          feildsErrors.push(obj.errorFields.receivedTo);
          obj.errorStatus.receivedTo = true;
          if (obj.errorStatus.receivedFrom !== true) {
            document.getElementById('receivedTo').focus();
          }
        } else if (obj.receivedFrom.value === obj.receivedTo.value) {
          isvalid = false;
          obj.errorFields.receivedTo = 'Received From and Received To should be different';
          obj.errorStatus.receivedTo = true;
          if (obj.errorStatus.receivedFrom !== true) {
            document.getElementById('receivedTo').focus();
          }
        } else {
          // isvalid=true;
          obj.errorFields.receivedTo = '';
          obj.errorStatus.receivedTo = false;
        }
      }
      if (itemKey === 'receivableAmount') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.receivableAmount = 'Amount Receivable Field is required';
          feildsErrors.push(obj.errorFields.receivableAmount);
          obj.errorStatus.receivableAmount = true;
          if (obj.errorStatus.receivedFrom !== true && obj.errorStatus.receivedTo !== true) {
            document.getElementById('receivableAmount').focus();
          }
        } else if (!new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(obj.receivableAmount)) {
          isvalid = false;
          obj.errorFields.receivableAmount = 'Invalid Amount';
          obj.errorStatus.receivableAmount = true;
          if (obj.errorStatus.receivedFrom !== true && obj.errorStatus.receivedTo !== true) {
            document.getElementById('receivableAmount').focus();
          }
        } else if (parseFloat(data[itemKey]) < parseFloat(state.tdsAmount)) {
          if (obj.errorStatus.paidTo !== true && obj.errorStatus.receivedTo !== true) {
            document.getElementById('receivableAmount').focus();
          }
          isvalid = false;
          obj.errorFields.receivableAmount = 'Amount should be greater than TDS';
          obj.errorStatus.receivableAmount = true;
        } else {
          obj.errorFields.receivableAmount = '';
          obj.errorStatus.receivableAmount = false;
        }
      }
      // if (state.tdsAmount > 0) {
      //   if (itemKey === "tdsApplicable") {
      //     if (data[itemKey]?.toString()?.trim().length <= 0) {
      //       isvalid = false;
      //       obj.errorFields.tdsApplicable = "TDS Applicable Field is required";
      //       obj.errorStatus.tdsApplicable = true;
      //     } else {
      //       // isvalid=true;
      //       obj.errorFields.tdsApplicable = "";
      //       obj.errorStatus.tdsApplicable = false;
      //     }
      //   }
      //   if (itemKey === "tdsAmount") {
      //     if (data[itemKey] == 0) {
      //       isvalid = false;
      //       obj.errorFields.tdsAmount = "TDS Amount Field is required";
      //       obj.errorStatus.tdsAmount = true;
      //     } else if (
      //       !new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(
      //         obj.tdsAmount
      //       )
      //     ) {
      //       isvalid = false;
      //       obj.errorFields.tdsAmount = "Invalid Amount";
      //       obj.errorStatus.tdsAmount = true;
      //     } else {
      //       // isvalid=true;
      //       obj.errorFields.tdsAmount = "";
      //       obj.errorStatus.tdsAmount = false;
      //     }
      //   }
      // }
      if (itemKey === 'receivedAmount') {
        if (obj.receivedAmount !== '' && !new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(obj.receivedAmount)) {
          isvalid = false;
          obj.errorFields.receivedAmount = 'Invalid Amount';
          feildsErrors.push(obj.errorFields.receivedAmount);
          obj.errorStatus.receivedAmount = true;
        } else {
          // isvalid=true;
          obj.errorFields.receivedAmount = '';
          obj.errorStatus.receivedAmount = false;
        }
      }
      // if (state.method == "BankReceipt") {
      //   if (itemKey === "bankRefNo") {
      //     if (
      //       obj.bankRefNo !== "" &&
      //       !/^[A-Z0-9\-\/_.]{9,18}$/.test(obj.bankRefNo)
      //     ) {
      //       isvalid = false;
      //       obj.errorFields.bankRefNo = "Invalid Bank Reference Number";
      //       obj.errorStatus.bankRefNo = true;
      //     } else {
      //       // isvalid=true;
      //       obj.errorFields.bankRefNo = "";
      //       obj.errorStatus.bankRefNo = false;
      //     }
      //   }
      // }
      if (itemKey === 'method') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.method = 'Please Select a Payment Method';
          obj.errorStatus.method = true;
        } else {
          // isvalid=true;
          obj.errorFields.method = '';
          obj.errorStatus.method = false;
        }
      }
      if (itemKey === 'vouchernumber') {
        const { valid, message } = CheckVoucherValid(data[itemKey], 'Voucher Number');
        if (data[itemKey]?.trim().length <= 0) {
          isvalid = false;
          obj.errorFields.vouchernumber = 'Voucher Number is Required';
          feildsErrors.push(obj.errorFields.vouchernumber);
          obj.errorStatus.vouchernumber = true;
        } else if (!valid) {
          isvalid = false;
          obj.errorFields.vouchernumber = message;
          obj.errorStatus.vouchernumber = true;
          feildsErrors.push(message);
        } else {
          let valid = true;
          receiptVoucherNos.map((ele) => {
            if (ele.VoucherNumber !== vouchNo) {
              if (ele.VoucherNumber === state.vouchernumber) {
                valid = false;
              }
            }
          });

          if (valid == false) {
            isvalid = false;
            obj.errorFields.vouchernumber = 'Voucher Number already exists';
            obj.errorStatus.vouchernumber = true;
          } else {
            obj.errorFields.vouchernumber = '';
            obj.errorStatus.vouchernumber = false;
          }
        }
      }
    });
    setState(obj);
    if (feildsErrors.length > 0) {
      showWarningSnackbar(
        feildsErrors.map((item) => item.replace('is required', '')).join(',') +
          `${feildsErrors.length > 1 ? ' are required' : ' is required'}`
      );
    }

    return isvalid;
  }

  async function listPartyMasterDetails() {
    try {
      return;
      let arr = [];
      const res = await API.graphql(graphqlOperation(listPartymasters));
      res.data.listPartymasters.map((ele) => {
        arr.push({ Name: ele.partylegalname, value: ele.partyid });
      });
      setPartyList(arr);
    } catch (error) {
      console.log('error', error);
    }
  }
  async function listInvoiceDetails() {
    try {
      setBackdropOpen(true);
      let arr = [];
      let transactionData = [];
      let partyData = [];
      const res = await API.graphql(graphqlOperation(listInvoiceMaster));
      res.data.listInvoiceMaster.map((ele) => {
        linkedData.map((subele) => {
          if (ele.InvoiceID == subele.InvoiceID) {
            transactionData.push(ele);
            arr.push({
              partyID: ele.PartyID,
              amount: subele.LinkedAmount,
            });
          }
        });
      });
      let CreditDetails = [];
      let DebitDetails = [];
      transactionData.map((ele) => {
        ele.RelatedInvoiceTransactionDetails.map((subele) => {
          subele.RelatedTransactionDetails.filter((childEle) => {
            if (childEle.DebitAmount == 0) {
              AllAccountsListing.map((ele) => {
                if (childEle.AccountID == ele.AccountsID) {
                  CreditDetails.push({
                    AccName: ele.AccountName,
                    Amount: childEle.CreditAmount,
                  });
                }
              });
            }
          });
          subele.RelatedTransactionDetails.filter((childEle) => {
            if (childEle.CreditAmount == 0) {
              AllAccountsListing.map((ele) => {
                if (childEle.AccountID == ele.AccountsID) {
                  DebitDetails.push({
                    AccName: ele.AccountName,
                    Amount: childEle.DebitAmount,
                  });
                }
              });
            }
          });
        });
      });

      const uniqueCredit = [];
      let creditTempArray = [];
      const creditUnique = CreditDetails.filter((element) => {
        let amount = 0;
        const isDuplicate = uniqueCredit.includes(element.AccName);
        if (!isDuplicate) {
          uniqueCredit.push(element.AccName);
          creditTempArray.push({
            Amount: element.Amount,
            AccName: element.AccName,
            editable: element.editable,
          });
          return true;
        } else {
          creditTempArray.map((item) => {
            if (element.AccName === item.AccName) {
              item.Amount += Number(element.Amount);
            }
          });
        }
        return false;
      });
      setCreditData(creditTempArray);
      const uniqueDebit = [];
      let debitTempArray = [];
      const debitUnique = DebitDetails.filter((element) => {
        let amount = 0;
        const isDuplicate = uniqueDebit.includes(element.AccName);
        if (!isDuplicate) {
          uniqueDebit.push(element.AccName);
          debitTempArray.push({
            Amount: element.Amount,
            AccName: element.AccName,
            editable: element.editable,
          });
          return true;
        } else {
          debitTempArray.map((item) => {
            if (element.AccName === item.AccName) {
              item.Amount += Number(element.Amount);
            }
          });
        }
        return false;
      });
      setDebitData(debitTempArray);
      const uniqueIds = [];
      let tempArray = [];
      let newArray = [];
      const unique = arr.filter((element) => {
        let amount = 0;
        const isDuplicate = uniqueIds.includes(element.partyID);
        if (!isDuplicate) {
          uniqueIds.push(element.partyID);
          tempArray.push({
            Amount: element.amount,
            PartyID: element.partyID,
            editable: element.editable,
          });
          return true;
        } else {
          tempArray.map((item) => {
            if (element.partyID === item.PartyID) {
              item.Amount += Number(element.amount);
            }
          });
        }
        return false;
      });
      partylist.map((ele) => {
        tempArray.map((subele) => {
          if (subele.PartyID == ele.value) {
            partyData.push({ PartyName: ele.Name, Amount: subele.Amount });
          }
        });
      });
      setInvoiceEntry(partyData);
    } catch (error) {
      console.log('error', error);
    } finally {
      setBackdropOpen(false);
    }
  }
  async function listUserPreferenceData() {
    try {
      // const res = await API.graphql(graphqlOperation(listUserPreference));
      // let attributeValue = "";
      // res?.data?.listUserPreference.map((ele) => {
      //   if (ele.AttributeTypeCD == "SelectedFinYear")
      //     attributeValue = ele.AttributeValue;
      // });
      getFY(userPreferece?.financialYear?.FinancialYearID);
      // setUserPrefernceId(attributeValue);
      // dispatch(fySettingsfalse());
    } catch (error) {
      console.log('error', error);
    }
  }

  async function getFY(data) {
    try {
      let startDate = new Date(userPreferece.financialYear.StartDate * 1000).toString().split(' ');
      let endDate = new Date(Number(userPreferece.financialYear.EndDate) * 1000).toString().split(' ');

      let FyearStart = startDate[1] + ' ' + startDate[2] + ' ' + startDate[3];
      let FyearEnd = endDate[1] + ' ' + endDate[2] + ' ' + endDate[3];
      const formatDateString = (dateStr) => moment(dateStr, 'MMM DD YYYY').format('YYYY-MM-DD');

      const formattedStartDate = formatDateString(FyearStart);
      const formattedEndDate = formatDateString(FyearEnd);
      setCompanyFinYrStartDate(formattedStartDate);
      setCompanyFinYrEndDate(formattedEndDate);
    } catch (error) {
      console.log('Error', error);
    }
  }

  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);
  const companyLoaded = useSelector((state) => state?.companyReducer.Loaded);

  // useEffect(() => {
  //   listPartyMasterDetails();
  // }, [linkedData]);
  useEffect(() => {
    if (location?.state?.name) {
      getAccountName();
    }
  }, [AllAccountsListing, location?.state?.name]);

  useEffect(() => {
    let partyID = '';
    partylist.map((ele) => {
      if (ele.Name == state.receivedFrom.label) {
        partyID = ele.value;
      }
    });
    setCustomerID(partyID);
  }, [state.receivedFrom]);

  useEffect(() => {
    getItemSettings();
    listPartyMasterDetails();
  }, [generalSettings]);
  // useEffect(() => {
  //   getAccountMasterData();
  // }, [fromAccountModal, openBankModal]);
  useEffect(() => {
    if (Object.keys(entryData).length > 0 && AllAccountsListing.length) {
      displayReceiptDetails();
    }
  }, [entryData]);

  useEffect(() => {
    if (state.receivedFrom.value) {
      getFromAccountBalanceAmount(`${state.receivedFrom.value}`);
    }
    if (state.receivedTo.value) {
      getToAccountBalanceAmount(`${state.receivedTo.value}`);
    }
  }, [state.receivedFrom, state.receivedTo]);

  useEffect(() => {
    getTdsDetails();
    listVoucherNos();
    listUserPreferenceData();
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    }
  }, []);
  const journalHTML = `
  <html>
    <head>
      <meta name="viewport" />
    </head>
    <body>
      <table cellpadding="2" cellspacing="0" width="100%" 
       style="margin-top: 10px; border-collapse: collapse; border: solid 1px ${theme.palette.background.tablebg}">
        <thead>
          <tr style="font-size:15px; background-color: ${theme.palette.background.tablebg}">
            <td width="60%" style="padding: 5px; font-size: 13px; border: solid 1px ${theme.palette.background.tablebg};">Particulars</td>
            <td width="20%" align="center" style="padding: 5px; font-size: 13px; text-align: right; border: solid 1px ${
              theme.palette.background.tablebg
            };">Debit(₹)</td>
            <td width="20%" align="center" style="padding: 5px; font-size: 13px; text-align: right; border: solid 1px ${
              theme.palette.background.tablebg
            };">Credit(₹)</td>
          </tr>
        </thead>
        <tbody>
            ${
              state.receivedTo.label !== ''
                ? `<tr style="color:#396afc; font-size:13px; border: solid 1px ${theme.palette.background.tablebg}; height:30px">
               <td width="60%" style="border: solid 1px ${theme.palette.background.tablebg}; font-size:13px"> ${
                    state.receivedTo.label
                  } </td>
               <td width="20%" align="center" style="border: solid 1px ${theme.palette.background.tablebg}; text-align: right">
      ${MoneyFormatv3(
        state.tdsAmount
          ? (Number(state.receivableAmount).toFixed(2) - Number(state.tdsAmount).toFixed(2)).toFixed(2)
          : Number(state.receivableAmount).toFixed(2)
      )}
      </td>
               <td width="20%" align="center" style="border: solid 1px ${theme.palette.background.tablebg};"></td>
          </tr>`
                : ``
            }
    ${
      state.tdsAmount > 0
        ? `<tr style="color:#396afc; font-size:13px; height:30px">
      <td width="60%" style="border: solid 1px ${theme.palette.background.tablebg}; font-size: 13px"> TDS Receivable</td>
   <td width="20%" align="center" style="border: solid 1px ${
     theme.palette.background.tablebg
   }; text-align: right; font-size:13px">${MoneyFormatv3(Number(state.tdsAmount).toFixed(2))}</td>
   <td width="20%" align="center" style="border: solid 1px ${theme.palette.background.tablebg};"></td>
 </tr>`
        : ``
    }
     
         ${
           state.receivedFrom.label !== ''
             ? `<tr style="color:#20e0cf;">
              <td width="60%" style="padding-left: 25px; border: solid 1px ${theme.palette.background.tablebg}; font-size:13px"> To ${
                 state.receivedFrom.label
               } </td>
              <td width="20%" align="center" style="border: solid 1px ${theme.palette.background.tablebg};"></td>
              <td width="20%" align="center" style="border: solid 1px ${
                theme.palette.background.tablebg
              }; text-align: right; font-size:13px">${MoneyFormatv3(Number(state.receivableAmount).toFixed(2))}</td>
           </tr>`
             : ``
         }
  
        </tbody>
      </table>
    </body>
  </html>
  `;

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.option,
  });
  let saveV = true;

  function deepEqual(obj1, obj2, ignoredKeys = ['date']) {
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return obj1 == obj2;
    }

    let keys1 = Object.keys(obj1).filter((key) => !ignoredKeys.includes(key));
    let keys2 = Object.keys(obj2).filter((key) => !ignoredKeys.includes(key));

    if (keys1.length !== keys2.length) {
      return false;
    }

    // Check if all keys and values are the same
    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        console.log(`Key "${key}" does not match:`, {
          obj1Value: obj1[key],
          obj2Value: obj2[key],
        });
        return false;
      }
    }

    return true;
  }

  const [reloadFn, setReloadFn] = useState(false);
  let aaaa = false; // not inuse but it's mandatory in this function
  useEffect(() => {
    window.addEventListener('click', (e) => {
      if (e.target.innerText === 'SAVE & NEW') {
        setReloadFn(true);
        aaaa = true;
      }
    });
    if (state?.vouchernumber) {
      dispatch(updateTitle(state.vouchernumber));
    }
  }, [state]);

  const [reNavigate, setReNavigate] = useState('');

  let clickFn = (e) => {
    if (!deepEqual(state, initialState) || attachments.length !== initialAttachments.length) {
      if (!cancelModal) {
        e.preventDefault();
        e.stopPropagation();
        setModalOpen(true);
      }
      return;
    }
    if (attachments.length === initialAttachments.length) {
      attachments.map((e, index) => {
        if (!deepEqual(attachments[index], initialAttachments[index])) {
          if (!cancelModal) {
            e.preventDefault();
            e.stopPropagation();
            setModalOpen(true);
          }
          return;
        }
      });
    }
  };

  const [aTags, setATags] = useState(document.getElementsByTagName('a').length);
  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer);

  useEffect(() => {
    setATags(document.getElementsByTagName('a').length);
    if (selectorDrawer == true) {
      setTimeout(() => {
        setATags(document.getElementsByTagName('a').length);
      }, 50);
    }
  }, [selectorDrawer, selector]);

  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (params.view) return;
    const isDataModified = !deepEqual(state, initialState);
    const isAttachmentsModified = attachments.length !== initialAttachments.length;
    const shouldBeDirty = isDataModified || isAttachmentsModified;
    if (shouldBeDirty !== isDirty) {
      setIsDirty(shouldBeDirty);
    }
  }, [state, aTags, attachments, isDirty]);

  useEffect(() => {
    dispatch(setNavigationBlocked(isDirty));
  }, [isDirty, dispatch]);

  let [modalOpen, setModalOpen] = useState(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    // p: 4,
    outline: 'none',
    minWidth: '400px',
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    const allowedTypes = [
      'application/msword',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'image/jpeg',
      'image/jpg',
      'image/png',
    ];

    let allFilesValid = true;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!allowedTypes.includes(file.type)) {
        showWarningSnackbar('This format is not allowed');
        allFilesValid = false;
        break;
      }
    }

    if (allFilesValid) {
      setAttachments((currentAttachments) => {
        if (attachments.length + files.length > 6) {
          showWarningSnackbar('You cannot add more than 6 attachments');
          return currentAttachments;
        }

        const newAttachments = Array.from(files).map((file) => ({
          attachmentid: currentAttachments.attachmentid ? currentAttachments.attachmentid : Date.now() + file.name,
          imagename: currentAttachments.attachmentname
            ? currentAttachments.attachmentname
            : path + 'Receipts/${id}/LedgerX_' + Date.now() + file.name,
          documentname: file.name,
          type: currentAttachments.type ? currentAttachments.type : file.type,
          imageurl: currentAttachments.imageurl ? currentAttachments.imageurl : URL.createObjectURL(file),
          file,
        }));

        const filteredNewAttachments = newAttachments.filter(
          (newAttachment) => !currentAttachments.some((attachment) => attachment.documentname === newAttachment.documentname)
        );

        return [...currentAttachments, ...filteredNewAttachments];
      });
    } else {
      // Optionally clear the file input if invalid file detected
      event.target.value = ''; // This resets the file input
    }

    if (imageRef.current) {
      imageRef.current.value = '';
    }
  };
  const [focusRadioGrp, setFocusRadioGrp] = useState(false);
  const calculateBalance = (value, noSymbol) => {
    let post = '';
    if (value > 0) {
      post = '(Dr)';
    } else if (value < 0) {
      post = '(Cr)';
    }
    if (noSymbol) {
      return value;
    }
    value = Math.abs(value);
    return MoneyFormatv3(value) + ' ' + post;
  };
  const [vouchers, setvouchers] = useState([]);
  const [LinkedVouchers, setLinkedVouchers] = useState({});
  let getTransactions = async (value, voucherNumber, invoicenumber) => {
    try {
      console.log({ value, voucherNumber, invoicenumber });
      let responses = await Promise.all([
        !params.view
          ? API.graphql(
              graphqlOperation(listPartyInvoicePurchases, {
                accountid: value,
              })
            )
          : '',
        voucherNumber
          ? API.graphql(
              graphqlOperation(getLinkedReceipts, {
                vouchernumber: voucherNumber,
              })
            )
          : '',
      ]);
      let response = responses[0];
      let linkedTransactionResponse = responses[1];
      let linkedTransactions = new Set(
        linkedTransactionResponse?.data?.getLinkedReceipts?.map((elem) => {
          if (elem.transactiontypecd === 'PosInvoice') {
            setViewMode(true);
          }
          let Total = elem.invoiceamount || elem.grandtotalamount;
          let InvoiceId = elem.purchaseid || elem.invoiceid || elem.objectid;
          let dueAmount = elem.balancedueamount || 0;
          let ObjectAttribute = elem.invoicenumber || elem.invoicenumber;
          return {
            PreviousLinkedAmount: elem.linkedamount,
            LinkedAmount: elem.linkedamount,
            TransactionTypeCD: elem.transactiontypecd,
            ObjectAttribute: ObjectAttribute,
            IsDirect: 0,
            ObjectID: InvoiceId,
            ObjectType: elem.objecttype,
            TransactionID: elem.transactionid,
            dueAmount,
            Total,
            invoicedate: elem.invoicedate,
          };
        })
      );
      let transactions = [];
      if (!params.view) {
        console.log({ linkedTransactions }, response.data.listPartyInvoicePurchases);
        transactions =
          response.data.listPartyInvoicePurchases
            .filter(
              (elem) =>
                !Array.from(linkedTransactions).find((ele) => ele.ObjectAttribute == elem.invoicenumber) &&
                elem.invoicetypecd !== 'CreditNote' &&
                elem.invoicetypecd !== 'PurchaseInvoice'
            )
            .filter((elem) => (invoicenumber ? elem.vouchernumber == invoicenumber || elem.invoicenumber == invoicenumber : true))
            .map((elem) => {
              let Total = elem.invoiceamount || elem.grandtotalamount;
              let InvoiceId = elem.purchaseid || elem.invoiceid || elem.objectid;
              let dueAmount = elem.purchasebalancedueamount || elem.invoicebalancedueamount;
              let ObjectAttribute = elem.vouchernumber || elem.invoicenumber;

              return {
                PreviousLinkedAmount: 0,
                LinkedAmount: 0,
                TransactionTypeCD: state.method,
                ObjectAttribute: ObjectAttribute,
                IsDirect: 0,
                ObjectID: InvoiceId,
                ObjectType: elem.invoicetypecd,
                TransactionID: '',
                dueAmount,
                Total,
                invoicedate: elem.invoicedate,
              };
            }) || [];
      }
      let mergedVouchers = [...transactions];
      if (linkedTransactionResponse) {
        mergedVouchers = [...Array.from(linkedTransactions), ...mergedVouchers];
        setLinkedVouchers([...Array.from(linkedTransactions)]);
      }
      setvouchers(mergedVouchers);
    } catch (error) {
      console.log(error);
    }
  };
  let handleLinkedAmount = (value, index) => {
    console.log(value, vouchers);
    let temp = JSON.parse(JSON.stringify(vouchers));
    let availableBalance = balanceInReceipt(index);
    let check = true;
    if (value > temp[index].Total) {
      return showWarningSnackbar('Amount is greater than invoice amount');
    }
    if (availableBalance < value && value >= temp[index].LinkedAmount) {
      temp[index].LinkedAmount = availableBalance;
      setvouchers(temp);
      showWarningSnackbar('no balance left !');
      return false;
    }
    if (typeof value == 'boolean') {
      if (value == true) {
        let balance =
          Number(temp[index].dueAmount) + (Number(temp[index].PreviousLinkedAmount || 0) + Number(temp[index].LinkedAmount || 0));
        if (balance > availableBalance) {
          value = availableBalance;
        } else {
          value = balance;
        }
      } else {
        value = 0;
        // temp[index].dueAmount+=temp[index].LinkedAmount;
      }
    }

    temp[index].LinkedAmount = value;
    setvouchers(temp);
    return check;
  };

  let balanceInReceipt = (index = undefined) => {
    let balance = state.receivableAmount;
    let linkedTotal = vouchers.reduce((sum, item, indexx) => sum + Number(index != indexx ? item.LinkedAmount : 0), 0);
    return Number(balance) - Number(linkedTotal);
  };
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  // useSaveShortcut(
  //   params?.id && params?.view !== true
  //     ? () => {
  //       saveEditChanges();
  //     }
  //     : params?.view !== true
  //       ? () => saveChanges({ new: false })
  //       : undefined
  // );
  // console.log(state,"====>state")
  useSaveShortcutV1(
    params?.id && params?.view !== true
      ? () => {
          saveEditChanges();
        }
      : params?.view !== true
      ? () => saveChanges({ new: false })
      : undefined,
    accountIDTransaction,
    settingsModal,
    openBankModal,
    fromAccountModal ? true : false
  );

  function handleKeyDown(e) {
    if ((e.key === 'Tab' || e.key === 'Enter') && state?.receivedFrom?.label === '') {
      e.stopPropagation();
      e.preventDefault();
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          receivedFrom: true,
        },
        errorFields: {
          ...prev.errorFields,
          receivedFrom: ' Received From Field Is required',
        },
      }));
    }
  }

  const BalanceAmountCalculator = ({ balance = 0, balanceSign = 1, oldBalance = 0, newBalance, sign, oldAccountid, newAccountid }) => {
    console.log({
      balance,
      balanceSign,
      oldBalance,
      newBalance,
      sign,
      amountsFromTable,
    });
    let result = 0;
    let temp = oldAccountid == newAccountid ? newBalance - oldBalance : newBalance;
    if (sign === 'credit' && balanceSign === 1) {
      result = calculateBalance((balance + temp) * -1);
    } else if (sign === 'debit' && balanceSign === -1) {
      result = calculateBalance(balance + temp);
    } else {
      result = calculateBalance((balance - temp) * -balanceSign);
    }
    console.log(result);
    return result;
  };
  console.log(viewMode, entryData?.cancelflag);

  const handleKeyDownn = (e) => {
    if ((e.key === 'Tab' || e.key === 'Enter') && state.receivableAmount === '') {
      e.preventDefault();
      e.stopPropagation();
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          receivableAmount: true,
        },
        errorFields: {
          ...prev.errorFields,
          receivableAmount: 'Amount Receivable field is required',
        },
      }));
    }
  };

  const handleTdsKeyPress = (e) => {
    if ((e.key === 'Tab' || e.key === 'Enter') && state.tdsApplicable && state.tdsAmount === '') {
      e.preventDefault();
      e.stopPropagation();
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          payabltdsAmounteAmount: true,
        },
        errorFields: {
          ...prev.errorFields,
          tdsAmount: 'TDS Amount is required',
        },
      }));
    }
  };

  const handleTdsPercent = (e) => {
    if ((e.key === 'Tab' || e.key === 'Enter') && state.TDSPercentage === '') {
      e.preventDefault();
      e.stopPropagation();
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          TDSPercentage: true,
        },
        errorFields: {
          ...prev.errorFields,
          TDSPercentage: ' % required',
        },
      }));
    }
  };

  return (
    <Box
      className="PageHeight"
      sx={{
        width: '100%',
        // paddingTop: modalEvent == true ? "0px" : "60px",
        // paddingRight: modalEvent === true ? "0px" : "0px",
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ConfirmExit open={modalOpen} setOpen={setModalOpen} reNavigate={reNavigate} />
      <Box
        sx={{
          display: {
            xs: 'none',
            sm: 'flex',
            md: 'flex',
            lg: 'flex',
            xl: 'flex',
          },
          justifyContent: 'space-between',
          marginTop: '15px',
          marginBottom: '10px',
        }}
      ></Box>
      <Box>
        {/* {viewMode == true && entryData?.CancelFlag !== undefined && (
          <Alert
            variant="standard"
            sx={{ boxShadow: "none", marginBottom: "20px" }}
            severity="info"
          >
            {entryData.CancelFlag === 0
              ? ` Fields are disabled. To make changes${" "}`
              : entryData.CancelFlag === 1
                ? "Invoice cancelled. No further updates can be made."
                : null}
            {entryData.CancelFlag === 0 ? (
              <Link
                id="editN"
                underline="hover"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  if (Freeze == 1) {
                    return handleFreeze();
                  }
                  setViewMode(false);
                  navigate("/editreceipts", {
                    state: { id: entryData.TransactionID },
                  });
                }}
              >
                Enable Edit&nbsp;
                <EditIcon sx={{ fontSize: "14px", color: "#6096d9" }} />
              </Link>
            ) : null}
          </Alert>
        )} */}
        {viewMode === true && entryData.cancelflag ? (
          <>
            <Box
              sx={{
                position: 'sticky',
                top: '10px',
                borderRadius: '8px',
                marginBottom: '0px',
                padding: { xs: '10px 0px', sm: '10px 10px' },
                transition: 'all 1s ease-in-out',
              }}
            >
              <Alert
                variant="standard"
                sx={{
                  color: entryData.cancelflag === 0 ? '' : 'red',
                  boxShadow: 'none',
                  width: 450,
                }}
                severity="error"
              >
                {entryData.cancelflag === 1 ? 'Receipt cancelled. No further updates can be made.' : null}
              </Alert>
            </Box>
            <Box sx={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '10' }}>
              <CancelUI />
            </Box>
          </>
        ) : null}

        <Box
          className="darkDisabledInputs"
          sx={{
            opacity: viewMode === true && entryData?.cancelflag ? '1' : '1',
            cursor: viewMode === true && entryData?.cancelflag ? 'no-drop' : 'default',
          }}
        >
          <Box
            sx={{
              borderRadius: '8px',
              marginBottom: '20px',
              // boxShadow:
              //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
              padding: { xs: '30px 20px ', sm: '0px 0px' },
              borderRadius: '8px',
              ':hover': {
                boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
              },
              transition: 'all 1s ease-in-out',
            }}
          >
            {/* {!params.view && <PageTitle>Add Receipt Voucher</PageTitle>} */}

            <Grid container rowSpacing={1} columnSpacing={1}>
              {/* <Grid item xs={12} sx={{ paddingRight: "10px" }}>
              <HeadingWithRuler text={"General Details"} />
            </Grid> */}

              <Grid
                item
                container
                sx={{ marginTop: entryData?.cancelflag ? '-1px !important' : '-16px !important' }}
                rowSpacing={{ xs: 2, md: 0 }}
                columnSpacing={1}
              >
                <Grid
                  item
                  xs={12}
                  md={3}
                  // sx={{ padding: "0px 10px", marginTop: "10px" }}
                >
                  <Box sx={{ flex: { xs: 1 } }}>
                    <Box
                      onFocus={() => {
                        setFocusRadioGrp(true);
                      }}
                      onBlur={() => {
                        setFocusRadioGrp(false);
                      }}
                      onKeyDown={(e) => {
                        if (e.key == 'Enter') {
                          if (state.method == 'CashReceipt') {
                            setState((prev) => ({
                              ...prev,
                              method: 'BankReceipt',
                              receivedTo:
                                bankAccountObj?.label !== ''
                                  ? {
                                      label: bankAccountObj?.label,
                                      value: bankAccountObj?.value,
                                    }
                                  : {
                                      label: BankAccountsListing[0]?.label,
                                      value: BankAccountsListing[0]?.value,
                                    },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              method: 'CashReceipt',
                              receivedTo:
                                cashAccountObj?.label !== ''
                                  ? {
                                      label: CashAccountsListing?.label,
                                      value: CashAccountsListing?.value,
                                    }
                                  : {
                                      label: CashAccountsListing[0]?.label,
                                      value: CashAccountsListing[0]?.value,
                                    },
                            }));
                          }
                        }
                      }}
                      sx={{
                        position: 'relative',
                        border: 'solid 1px',
                        borderColor: state.errorStatus.method === true ? 'danger.main' : 'input.border',
                        borderRadius: '4px',
                        height: '100%',
                        padding: '5px 14px',
                        boxSizing: 'border-box',
                        '.css-ahj2mt-MuiTypography-root': {
                          fontSize: '12px',
                          color: 'input.font',
                        },
                        '.css-1n70hd2-MuiButtonBase-root-MuiRadio-root': {
                          padding: '0px',
                          margin: '0px 5px',
                        },
                        '.css-1rfdfc4-MuiButtonBase-root-MuiRadio-root': {
                          padding: '0px',
                          margin: '0px 5px',
                          color: 'input.border',
                        },
                        '.css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked': {
                          color: 'primary.main',
                        },
                        boxShadow: focusRadioGrp ? '0px 6px 8px rgba(0, 0, 0, 0.5)' : '',
                        '&:focus-within': {
                          backgroundColor: '#ffb74d', // Background when focused
                        },
                      }}
                    >
                      <Typography
                        error={state.errorStatus.method === true ? true : false}
                        required={true}
                        sx={{
                          fontSize: { xs: '0.75rem', sm: '0.60em' },
                          letterSpacing: '0.00938em',
                          position: 'absolute',
                          top: '-8px',
                          left: '11px',
                          background: theme?.palette?.TmId.id.toString().includes('9') ? '#373843' : '#fff',
                          padding: '0px 8px 0px 2px',
                          color: state.errorStatus.method == true ? 'danger.main' : 'input.font',
                        }}
                      >
                        Received By
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <RadioGroup
                          disabled={viewMode == true || currentPaymentFlag == true ? true : false}
                          variant="outlined"
                          sx={{
                            display: 'flex',
                            flexDirection: { xs: 'row', sm: 'row' },
                          }}
                          name="method"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === '') {
                              setPaymentFlag(false);
                              setState((prev) => ({
                                ...prev,
                                method: value,

                                errorStatus: {
                                  ...prev.errorStatus,
                                  method: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  method: 'Please Select Payment Type',
                                },
                              }));
                            } else {
                              setPaymentFlag(true);
                              if (CashAccountsListing.length > 0 && value === 'CashReceipt') {
                                let acc =
                                  AllAccountsListing.find((elem) => elem.value == lastCashAccount) ||
                                  cashAccountObj ||
                                  CashAccountsListing[0];
                                setState((prev) => ({
                                  ...prev,
                                  method: value,
                                  bankRefNo: '',
                                  receivedTo: acc?.label
                                    ? {
                                        label: acc?.label,
                                        value: acc?.value,
                                      }
                                    : {
                                        label: '',
                                        value: '',
                                      },
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    method: false,
                                    receivedTo: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    method: '',
                                    receivedTo: '',
                                  },
                                }));
                              } else if (BankAccountsListing.length > 0 && value === 'BankReceipt') {
                                let bankAc = JSON.parse(JSON.stringify(BankAccountsListing));
                                let acc =
                                  AllAccountsListing.find((elem) => elem.value == LastBankAccount) ||
                                  BankAccountsListing.find((elem) => elem.value == 39) ||
                                  BankAccountsListing[0];
                                setState((prev) => ({
                                  ...prev,
                                  method: value,
                                  receivedTo: acc?.label
                                    ? {
                                        label: acc?.label,
                                        value: acc?.value,
                                      }
                                    : {
                                        label: '',
                                        value: '',
                                      },
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    method: false,
                                    receivedTo: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    method: '',
                                    receivedTo: '',
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  method: value,
                                  receivedTo: { label: '', value: '' },
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    method: false,
                                    receivedTo: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    method: '',
                                    receivedTo: '',
                                  },
                                }));
                              }
                            }
                          }}
                          value={state.method}
                        >
                          <FormControlLabel
                            disabled={viewMode == true || currentPaymentFlag == true ? true : false}
                            name="method"
                            value="CashReceipt"
                            control={<Radio size="small" />}
                            label="Cash"
                          />
                          <FormControlLabel
                            disabled={viewMode == true || currentPaymentFlag == true ? true : false}
                            name="method"
                            value="BankReceipt"
                            control={<Radio size="small" />}
                            label="Bank"
                          />
                        </RadioGroup>
                        <>{!state.method && <CheckIcon className={classes.check} />}</>
                      </Box>
                    </Box>
                    <Typography className="error" sx={{ minHeight: '12px' }}>
                      {state?.errorFields.method}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3} sx={{ padding: '0px 0px', marginTop: '0px' }}>
                  <Box sx={{ flex: { xs: 1, sm: 0.5 } }}>
                    <TextField
                      error={state.errorStatus.date === true ? true : false}
                      id="paymentDate"
                      label="Receipt Date"
                      variant="outlined"
                      size="small"
                      disabled={paymentFlag == false || viewMode === true || currentPaymentFlag == true ? true : false}
                      type="date"
                      value={state.date}
                      // onChange={(e) => {
                      //   const value = e.target.value;

                      //   const startDate = moment(
                      //     userPreferece.financialYear.startdate * 1000
                      //   ).format("YYYY-MM-DD");
                      //   const endDate = moment(
                      //     userPreferece.financialYear.enddate * 1000
                      //   ).format("YYYY-MM-DD");

                      //   if (value !== "") {
                      //     if (
                      //       moment(value).isBetween(
                      //         startDate,
                      //         endDate,
                      //         undefined,
                      //         "[]"
                      //       )
                      //     ) {
                      //       setState((prev) => ({
                      //         ...prev,
                      //         date: value,
                      //         errorStatus: {
                      //           ...prev.errorStatus,
                      //           date: false,
                      //         },
                      //         errorFields: {
                      //           ...prev.errorFields,
                      //           date: "",
                      //         },
                      //       }));
                      //     } else {
                      //       setState((prev) => ({
                      //         ...prev,
                      //         date: value,
                      //         errorStatus: {
                      //           ...prev.errorStatus,
                      //           date: true,
                      //         },
                      //         errorFields: {
                      //           ...prev.errorFields,
                      //           date: "Date must be within the financial year range",
                      //         },
                      //       }));
                      //     }
                      //   }
                      // }}

                      onChange={(e) => {
                        const value = e.target.value;
                        handleReceiptDateChanges(value);
                      }}
                      InputProps={{
                        inputProps: {
                          min:
                            // params?.id && !isNaN(params.id)
                            //   ? firstInvoiceDate ||
                            // moment(openingBalanceDate, 'YYYY-MM-DD').format('YYYY-MM-DD') !== 'Invalid date'
                            // ? moment(openingBalanceDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
                           openingBalanceDate ? openingBalanceDate : moment(userPreferenceAndFY.financialYear.startdate * 1000).format('YYYY-MM-DD'),
                          // : lastInvoiceDate ||
                          // moment(
                          //   userPreferenceAndFYDate.financialYear.startdate *
                          //   1000
                          // ).format("YYYY-MM-DD"),
                          max:
                            // params?.id && !isNaN(params.id)
                            //   ? nextInvoiceDate ||
                            moment(userPreferenceAndFYDate?.financialYear?.enddate * 1000).format('YYYY-MM-DD'),
                          // : moment(
                          //   userPreferenceAndFYDate.financialYear.enddate *
                          //   1000
                          // ).format("YYYY-MM-DD"),
                        },
                      }}
                      fullWidth
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                          color: '#e2e4ee',
                        },
                        '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                          borderColor: '#e2e4ee',
                        },
                        '.css-1cqhiog-MuiInputBase-root-MuiOutlinedInput-root': {
                          color: '#a0a1a1c7',
                        },
                        '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                          color: '#a0a1a1c7',
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <Typography className="error" sx={{ minHeight: '12px', fontSize: '12px' }}>
                      {state.errorFields.date}
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                  // sx={{ padding: "0px 10px", marginTop: "10px" }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {generalSettingsFlag !== -1 && (
                      <Box sx={{ flex: { xs: 1 }, mr: 1 }}>
                        <Autocomplete
                          openOnFocus
                          disablePortal
                          disabled={
                            isVoucherEditable && !viewMode && params?.id
                              ? false
                              : paymentFlag == false || viewMode === true || currentPaymentFlag == true || params?.id
                              ? true
                              : false
                          }
                          id="sereisVouchers"
                          options={serialNos}
                          disableClearable
                          value={state.vouchernumber}
                          isOptionEqualToValue={(option, value) => option?.value == value?.value}
                          onChange={(e, newValue) => {
                            let voucherNo = '';
                            if (newValue?.value !== '') {
                              activeVouchers.map((ele) => {
                                if (ele.serialnumber === newValue.value) {
                                  voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
                                }
                              });
                              if (!voucherNo) {
                                voucherNo = newValue?.value;
                              }
                              setState((prev) => ({
                                ...prev,
                                seriesVouchers: newValue,
                                vouchernumber: voucherNo,
                              }));
                            }
                          }}
                          sx={{
                            '.css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                              paddingBottom: '5px',
                            },
                            '.css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                              paddingTop: '6px',
                              paddingBottom: '5px',
                              paddingLeft: '6px',
                            },
                          }}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              sx={{
                                '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                                  padding: '8.5px 7px',
                                },
                                '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                                  fontSize: '14px',
                                },
                                label: {
                                  fontSize: '14px',
                                },
                                '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                                  fontSize: '14px',
                                },
                                '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                                  color: 'input.font',
                                },
                                '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'input.border',
                                },
                                '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                                  color: 'input.font',
                                },
                                '.css-14qz1ij-MuiListItemText-root': {
                                  margin: '0px',
                                },
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              required={false}
                              {...params}
                              label="Receipt Number Series"
                            />
                          )}
                        />
                        <Typography className="error" sx={{ minHeight: '12px' }}>
                          {state.errorFields.seriesVouchers}
                        </Typography>
                      </Box>
                    )}
                    {/* <Box sx={{ flex: 1, marginRight: "5px" }}> */}
                    {generalSettingsFlag === -1 ? (
                      <TextField
                        error={state.errorStatus.vouchernumber == true ? true : false}
                        name="vouchernumber"
                        label="Voucher Number "
                        size="small"
                        type="text"
                        disabled={
                          isVoucherEditable && !viewMode && params?.id
                            ? false
                            : paymentFlag == false || viewMode === true || currentPaymentFlag == true || params?.id
                            ? true
                            : false
                        }
                        fullWidth
                        value={state.vouchernumber}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          //  setItemCodeChange(true);
                          if (value == '') {
                            setState((prev) => ({
                              ...prev,
                              vouchernumber: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                vouchernumber: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                vouchernumber: 'Voucher Number is requierd',
                              },
                            }));
                          } else {
                            let isValid = true;
                            receiptVoucherNos.map((ele) => {
                              if (ele.VoucherNumber !== vouchNo) {
                                if (ele.VoucherNumber === value) {
                                  isValid = false;
                                }
                              }
                            });
                            if (isValid == false) {
                              setState((prev) => ({
                                ...prev,
                                vouchernumber: value,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  vouchernumber: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  vouchernumber: 'Voucher Number already exists',
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                vouchernumber: value,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  vouchernumber: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  vouchernumber: '',
                                },
                              }));
                            }
                          }
                        }}
                      />
                    ) : (
                      <>
                        {/* <Box
                          sx={{
                            display: "flex",
                            justifyContent: { sm: "flex-start" },
                            alignItems: "center",
                            padding: "8px",
                            borderRadius: "4px",
                            backgroundColor: "#a0a1a11a",
                            position: "relative",
                          }}
                        >
                          <Typography
                            sx={{
                              borderRadius: "4px",
                              paddingLeft: "8px",
                              paddingRight: "8px",
                              backgroundColor: "white",
                              position: "absolute",
                              top: "-6px",
                              left: "8px",
                              color: "#808080",
                              textTransform: "capitalize",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                          >
                            Voucher Number
                          </Typography>
                          <Typography sx={{ color: "#808080", paddingLeft: "4px" }}>
                            {state.vouchernumber}
                          </Typography>
                        </Box> */}
                      </>
                    )}
                    {/* <Typography className="error" sx={{ minHeight: "12px" }}>
                        {state?.errorFields.vouchernumber}
                      </Typography> */}
                    <ToolTipComponent
                      title="Voucher Number Settings"
                      placement="top"
                      tooltipContent={
                        <Button
                          disabled={
                            isVoucherEditable && !viewMode && params?.id
                              ? false
                              : paymentFlag == false || viewMode == true || currentPaymentFlag == true || params?.id
                              ? true
                              : false
                          }
                          sx={{ display: 'contents' }}
                          onClick={() => {
                            setSettingsModal(true);
                          }}
                        >
                          <SettingsIcon
                            sx={{
                              color: '#b5b5b5',
                              marginTop: '-12px',
                              zIndex: '99',
                            }}
                          />
                        </Button>
                      }
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                  // sx={{ padding: "0px 10px", marginTop: "10px" }}
                >
                  <Box sx={{ flex: { xs: 1 } }}>
                    <TextField
                      error={state.errorStatus.bankRefNo == true ? true : false}
                      label="Bank Reference Number"
                      id="bankRefNo"
                      disabled={
                        paymentFlag == false ||
                        viewMode === true ||
                        currentPaymentFlag == true ||
                        state.method !== 'BankReceipt' ||
                        (currentBankRefNo != '' && currentPaymentFlag == true)
                          ? true
                          : false
                      }
                      value={state.bankRefNo}
                      onChange={(e) => {
                        const value = e.target.value;
                        // if (value !== "" && !/^[A-Z0-9\-\/_.]{9,18}$/.test(value)) {
                        //   setState((prev) => ({
                        //     ...prev,
                        //     bankRefNo: value,
                        //     errorStatus: {
                        //       ...prev.errorStatus,
                        //       bankRefNo: true,
                        //     },
                        //     errorFields: {
                        //       ...prev.errorFields,
                        //       bankRefNo: "Invalid Bank Reference Number",
                        //     },
                        //   }));
                        // } else {
                        if (value?.length >= 255) {
                          return showWarningSnackbar('Bank reference number cannot exceed 255 characters');
                        }
                        setState((prev) => ({
                          ...prev,
                          bankRefNo: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            bankRefNo: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            bankRefNo: '',
                          },
                        }));
                        // }
                      }}
                      fullWidth
                      size="small"
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                          color: 'input.font',
                        },
                        '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                          borderColor: 'input.border',
                        },
                      }}
                    />
                    <Typography className="error" sx={{ minHeight: '12px', fontSize: '12px' }}>
                      {state?.errorFields.bankRefNo}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid container item xs={12} md={12} columnSpacing={1}>
                <Grid container item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                      padding: '0px 10px',
                      marginTop: '0px',
                      border: theme?.palette?.TmId.id.toString().includes('9') ? 'solid 1px white' : 'solid 1px gray',
                      borderRadius: '4px',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '500px',
                        color: theme.palette.primary.main,
                        marginBottom: '2px',
                      }}
                    >
                      JOURNAL ENTRY
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: { sm: 'flex-start' },
                        // alignItems:'center',
                        // padding: "8px",
                        borderRadius: '4px',
                        // backgroundColor: theme.palette.background.tablebg,

                        // border: "solid 1px black",
                        color: '#595C66',
                        minHeight: '150px',
                        maxWidth: '100%',
                        overflow: 'scroll',
                        scrollbarWidth: 'none',
                        '&::-webkit-scrollbar': {
                          display: 'none',
                        },
                        position: 'relative',
                        '&:hover': {
                          cursor: 'pointer',
                        },
                      }}
                    >
                      <div dangerouslySetInnerHTML={{ __html: journalHTML }} />
                    </Box>
                  </Grid>

                  <Grid
                    xs={12}
                    md={12}
                    sx={{
                      textAlign: 'right',
                      // paddingRight: "15px",
                      marginTop: { xs: '10px', md: '10px' },
                      position: 'relative',
                    }}
                  >
                    <TeaxtareaField
                      name="remarks"
                      placeholder="Narration"
                      size="small"
                      fullWidth
                      rows={4}
                      maxLength={251}
                      value={state.remarks}
                      disable={paymentFlag == false || viewMode === true || currentPaymentFlag == true ? true : false}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (value.length > 250) {
                          setState((prev) => ({
                            ...prev,
                            remarks: value,
                            errorStatus: {
                              ...prev.errorStatus,
                              narration: true,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              narration: 'Narration must be less than 250 characters',
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            remarks: value,
                            errorStatus: {
                              ...prev.errorStatus,
                              narration: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              narration: '',
                            },
                          }));
                        }
                      }}
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                          color: 'input.font',
                        },
                        '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                          borderColor: 'input.border',
                        },
                        '.MuiInputBase-root': {
                          height: '100%',
                        },
                        '.MuiGrid-root': {
                          height: '100%',
                        },
                      }}
                    />
                    {state.errorStatus.narration && (
                      <Typography
                        sx={{
                          color: 'red',
                          fontSize: '12px',
                          marginTop: '4px',
                          textAlign: 'right',
                        }}
                      >
                        {state.errorFields.narration}
                      </Typography>
                    )}
                  </Grid>
                </Grid>

                <Grid container item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                  <Grid container item xs={12} md={12} sx={{ padding: '0px 0px' }}>
                    <Grid item xs={7} sm={8} sx={{ marginTop: '0px', paddingLeft: '0px' }}>
                      <Box sx={{ flex: { xs: 1 } }}>
                        <AccountInputv2
                          filter={[15]}
                          error={state?.errorFields.receivedFrom}
                          label={'Received From'}
                          options={AllAccountsListing}
                          addAccountModal={() => {
                            setNewPartyID('');
                            setAccountFlag(false);
                            setFromAccountModal(true);
                            setOpenModalEvent(true);
                          }}
                          disabled={
                            paymentFlag == false || viewMode === true || currentPaymentFlag == true || params.partyID ? true : false
                          }
                          isOptionEqualToValue={(option, value) => option.value == value.value}
                          value={state.receivedFrom}
                          id="receivedFrom"
                          onChange={(e, newValue) => {
                            setvouchers([]);
                            if (newValue.AccountTypeFlag == 1 || newValue.AccountTypeFlag == 2) {
                              getTransactions(newValue.value);
                            } else {
                              setvouchers([]);
                            }
                            if (!newValue) {
                              setState((prev) => ({
                                ...prev,
                                receivedFrom: { label: '', value: '' },
                                errorStatus: {
                                  ...prev.errorStatus,
                                  receivedFrom: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  receivedFrom: '',
                                },
                              }));
                            } else if (newValue === '') {
                              setState((prev) => ({
                                ...prev,
                                receivedFrom: newValue,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  receivedFrom: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  receivedFrom: ' Received From Field Is required',
                                },
                              }));
                            } else if (newValue?.value !== '' && state.receivedTo.value !== '') {
                              setAccountID(newValue?.value);
                              if (newValue?.value === state.receivedTo.value) {
                                setState((prev) => ({
                                  ...prev,
                                  receivedFrom: newValue,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    receivedFrom: true,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    receivedFrom: ' Received From and Received To should be different',
                                  },
                                }));
                              } else {
                                let accType = '';
                                AllAccountsListing.map((ele) => {
                                  if (ele.value === newValue?.value) {
                                    accType = ele.AccountGroupID;
                                  }
                                });
                                if (newValue.AccountTypeFlag == 1 || newValue.AccountTypeFlag == 2) {
                                  setAccountType(accType);
                                  setState((prev) => ({
                                    ...prev,
                                    receivedFrom: newValue,
                                    tdsApplicable: newValue.TDSSection ? newValue.TDSSection : '',
                                    TDSPercentage: newValue.TDSPercentage ? newValue.TDSPercentage : '',
                                    tdsAmount: prev.receivableAmount ? (prev.receivableAmount * newValue.TDSPercentage) / 100 : '',
                                    errorStatus: {
                                      ...prev.errorStatus,
                                      receivedTo: false,
                                      receivedFrom: false,
                                    },
                                    errorFields: {
                                      ...prev.errorFields,
                                      receivedTo: '',
                                      receivedFrom: '',
                                    },
                                  }));
                                } else {
                                  if (state.tdsAmount || state.tdsApplicable) {
                                    showWarningSnackbar('TDS is applicable only for customer or supplier !');
                                  }
                                  setState((prev) => ({
                                    ...prev,
                                    receivedFrom: newValue,
                                    tdsApplicable: '',
                                    tdsAmount: '',
                                    TDSPercentage: '',
                                    errorStatus: {
                                      ...prev.errorStatus,
                                      receivedFrom: false,
                                      tdsApplicable: false,
                                      tdsAmount: false,
                                      TDSPercentage: false,
                                    },
                                    errorFields: {
                                      ...prev.errorFields,
                                      receivedFrom: '',
                                      tdsApplicable: '',
                                      tdsAmount: '',
                                      TDSPercentage: '',
                                    },
                                  }));
                                }
                              }
                            } else {
                              let accType = '';
                              AllAccountsListing.map((ele) => {
                                if (ele.value === newValue?.value) {
                                  accType = ele.AccountGroupID;
                                }
                              });
                              setAccountType(accType);
                              setAccountID(newValue?.value);
                              setState((prev) => ({
                                ...prev,
                                receivedFrom: newValue,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  receivedFrom: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  receivedFrom: '',
                                },
                              }));
                            }
                          }}
                          onKeyDown={(e) => {
                            handleKeyDown(e);
                          }}
                        />
                        {state?.errorFields.receivedFrom ? (
                          <Typography className="error" sx={{ fontSize: '12px', minHeight: '12px' }}>
                            {state?.errorFields.receivedFrom}
                          </Typography>
                        ) : (
                          ''
                        )}
                        <Typography
                          sx={{
                            display: 'flex',
                            justifyContent: '',
                            flexDirection: 'column-reverse',
                          }}
                        >
                          {state.receivedFrom.value !== '' && state.errorStatus.receivedFrom == false && (
                            <Typography
                              sx={{
                                justifyContent: 'flex-end',
                                color:
                                  viewMode == true || paymentFlag == false
                                    ? 'input.border'
                                    : BalanceAmountCalculator({
                                        balance: FromBalanceAmountv2.balance,
                                        balanceSign: FromBalanceAmountv2.balanceSign,
                                        oldBalance: Number(amountsFromTable.receivableAmount),
                                        newBalance: Number(state.receivableAmount),
                                        sign: 'credit',
                                        oldAccountid: amountsFromTable.receivedFrom?.value,
                                        newAccountid: state?.receivedFrom?.value,
                                      }).includes('Cr')
                                    ? 'danger.main'
                                    : 'primary.main',
                                display: 'flex',
                                // flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: { xs: 'flex-start', sm: 'center' },
                                fontSize: '13px',
                                marginTop: { xs: '0px' },
                                '&.MuiTypography-root': {
                                  fontSize: { xs: '10px', lg: '12px' },
                                },
                              }}
                            >
                              Balance :
                              <a
                                className="myLink"
                                disabled={viewMode === true ? true : false}
                                // color={
                                //   viewMode == true || paymentFlag === false
                                //     ? "input.border"
                                //     : "primary.main"
                                // }
                                sx={{
                                  textDecoration: 'underline',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor: 'pointer',

                                  color:
                                    viewMode == true || paymentFlag == false
                                      ? 'input.border'
                                      : BalanceAmountCalculator({
                                          balance: FromBalanceAmountv2.balance,
                                          balanceSign: FromBalanceAmountv2.balanceSign,
                                          oldBalance: Number(amountsFromTable.receivableAmount),
                                          newBalance: Number(state.receivableAmount),
                                          sign: 'credit',
                                          oldAccountid: amountsFromTable.receivedFrom?.value,
                                          newAccountid: state?.receivedFrom?.value,
                                        })?.includes('Cr')
                                      ? 'danger.main'
                                      : 'primary.main',
                                  fontSize: '13px',
                                }}
                                href={`/LedgerTransactions/${state?.receivedFrom?.value}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setAccountIDTransaction(state?.receivedFrom?.value);
                                }}
                                // onClick={(event) => event.preventDefault()}
                              >
                                ₹{' '}
                                {/* {fromBalanceAmount -
                              (params?.id &&
                                state.receivedFrom.value ===
                                amountsFromTable?.receivedFrom?.value
                                ? Number(state.receivableAmount) -
                                Number(amountsFromTable.receivableAmount)
                                : Number(state.receivableAmount)) <
                              0
                              ? MoneyFormatv3(
                                Math.abs(
                                  fromBalanceAmount +
                                  (params?.id &&
                                    state.receivedFrom.value ===
                                    amountsFromTable?.receivedFrom?.value
                                    ? Number(state.receivableAmount) -
                                    Number(
                                      amountsFromTable.receivableAmount
                                    )
                                    : Number(state.receivableAmount))
                                )
                              ) + " (Cr)"
                              : fromBalanceAmount -
                                (params?.id &&
                                  state.receivedFrom.value ===
                                  amountsFromTable?.receivedFrom?.value
                                  ? Number(state.receivableAmount) -
                                  Number(amountsFromTable.receivableAmount)
                                  : Number(state.receivableAmount)) ==
                                0
                                ? MoneyFormatv3(
                                  Math.abs(
                                    fromBalanceAmount -
                                    (params?.id &&
                                      state.receivedFrom.value ===
                                      amountsFromTable?.receivedFrom?.value
                                      ? Number(state.receivableAmount) -
                                      Number(
                                        amountsFromTable.receivableAmount
                                      )
                                      : Number(state.receivableAmount))
                                  )
                                )
                                : MoneyFormatv3(
                                  Math.abs(
                                    fromBalanceAmount -
                                    (params?.id &&
                                      state.receivedFrom.value ===
                                      amountsFromTable?.receivedFrom?.value
                                      ? Number(state.receivableAmount) -
                                      Number(
                                        amountsFromTable.receivableAmount
                                      )
                                      : Number(state.receivableAmount))
                                  )
                                ) + " (Dr)"} */}
                                {BalanceAmountCalculator({
                                  balance: FromBalanceAmountv2.balance,
                                  balanceSign: FromBalanceAmountv2.balanceSign,
                                  oldBalance: Number(amountsFromTable.receivableAmount),
                                  newBalance: Number(state.receivableAmount),
                                  sign: 'credit',
                                  oldAccountid: amountsFromTable.receivedFrom?.value,
                                  newAccountid: state?.receivedFrom?.value,
                                })}
                              </a>
                            </Typography>
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={5} sm={4} sx={{ marginTop: '0px', padding: '0px  10px 0px 0px' }}>
                      <Box sx={{ flex: { xs: 1, sm: 1 } }}>
                        <MoneyInput
                          error={state.errorStatus.receivableAmount == true ? true : false}
                          state={state}
                          label="Receivable Amount"
                          id="receivableAmount"
                          name="receivableAmount"
                          variant="outlined"
                          disabled={paymentFlag == false || viewMode === true || currentPaymentFlag == true ? true : false}
                          value={state.receivableAmount}
                          onKeyDown={handleKeyDownn}
                          onChange={(e) => {
                            let value = e;
                            value = value.replace(/,/g, '');
                            if (value >= 10000000000) {
                              showWarningSnackbar('Receivable amount must be less than ₹1000 crore.');
                              return;
                            }
                            if (!/^\d*(?:\.\d*)?$/.test(value)) {
                              return;
                            }
                            if (/^\d*\.?\d{0,2}$/.test(value) == false) {
                              return;
                            }
                            let amount = 0;
                            if (state.tdsApplicable !== '') {
                              // amount = (value / 100) * state.tdsApplicable;
                              amount = Number(state.TDSPercentage * value) / 100;
                            } else {
                              amount = 0;
                            }
                            if (value == '' && state.receivedFrom.value) {
                              setState((prev) => ({
                                ...prev,
                                receivableAmount: value,
                                tdsAmount: prev.TDSManual ? prev.tdsAmount : amount,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  receivableAmount: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  receivableAmount: 'Amount Receivable field is required',
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                receivableAmount: value,
                                tdsAmount: prev.TDSManual ? prev.tdsAmount : `${amount}`,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  receivableAmount: false,
                                  tdsAmount: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  receivableAmount: '',
                                  tdsAmount: '',
                                },
                              }));
                            }
                          }}
                          onBlur={(e) => {
                            let value = e.target.value;
                            value = value.replace(/,/g, '');
                            let amount = 0;
                            if (state.tdsApplicable !== '') {
                              // amount = (value / 100) * state.tdsApplicable;
                              amount = Number(state.TDSPercentage * value) / 100;
                            } else {
                              amount = 0;
                            }
                            setState((prev) => ({
                              ...prev,
                              receivableAmount: value,
                              tdsAmount: prev.TDSManual ? prev.tdsAmount : `${amount}`,
                              errorStatus: {
                                ...prev.errorStatus,
                                receivableAmount: false,
                                tdsAmount: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                receivableAmount: '',
                                tdsAmount: '',
                              },
                            }));
                          }}
                          fullWidth
                          size="small"
                          sx={{
                            '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                              fontSize: '14px',
                            },
                            label: {
                              fontSize: '14px',
                            },
                            '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                              borderColor: 'input.border',
                            },
                            '.css-1ua80n0-MuiInputBase-input-MuiOutlinedInput-input': {
                              textAlign: 'right',
                            },
                          }}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: '2px',
                            marginLeft: '10px',
                            marginBottom: '0px',
                            fontSize: '11px',
                            color: 'danger.main',
                          }}
                        >
                          {state?.errorFields.receivableAmount}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ marginTop: '10px' }}>
                      <Autocomplete
                        openOnFocus
                        label="Less TDS Deductd by Customer"
                        name="tdsApplicable"
                        filterOptions={filterOptions}
                        id="tdsApplicable"
                        options={tdsSection}
                        value={state.tdsApplicable}
                        PaperComponent={({ children }) => <Paper style={{ width: 'fit-content', minWidth: '100%' }}>{children}</Paper>}
                        getOptionLabel={(value) => {
                          return tdsSection.find((option) => option.section == value)?.option || '';
                        }}
                        // getOptionLabel={(option) => {
                        //   console.log(option);
                        //   return option.section || '';
                        // }}
                        isOptionEqualToValue={(option, value) => option.section == value}
                        disabled={
                          paymentFlag == false ||
                          viewMode === true ||
                          currentPaymentFlag == true ||
                          (state.receivedFrom.AccountTypeFlag != 2 && state.receivedFrom.AccountTypeFlag != 1)
                            ? true
                            : false
                        }
                        onChange={(e, newValue) => {
                          const value = newValue?.section;
                          let codeValue = newValue?.value ? newValue?.value : 0;
                          // tdsSection.map((ele) => {
                          //   if (ele.section == value) {
                          //     codeValue = ele.value;
                          //   }
                          // });
                          let amount = Number(((state.receivableAmount / 100) * codeValue).toFixed(2));
                          if (!value) {
                            setState((prev) => ({
                              ...prev,
                              tdsApplicable: '',
                              TDSPercentage: 0,
                              tdsAmount: 0,
                              TDSManual: 0,
                              errorStatus: {
                                ...prev.errorStatus,
                                tdsApplicable: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                tdsApplicable: '',
                              },
                            }));
                          } else if (value == '') {
                            setState((prev) => ({
                              ...prev,
                              tdsApplicable: value,
                              TDSPercentage: codeValue,
                              tdsAmount: 0,
                              TDSManual: 0,
                              errorStatus: {
                                ...prev.errorStatus,
                                tdsApplicable: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                tdsApplicable: ' TDS Applicable Field is required',
                              },
                            }));
                          } else {
                            setopenCaptureTCSTDS(true);
                            setState((prev) => ({
                              ...prev,
                              tdsApplicable: value,
                              tdsAmount: `${amount}`,
                              TDSPercentage: codeValue,
                              TDSManual: 0,
                              errorStatus: {
                                ...prev.errorStatus,
                                tdsApplicable: false,
                                tdsAmount: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                tdsApplicable: '',
                                tdsAmount: '',
                              },
                            }));
                          }
                        }}
                        size="small"
                        renderOption={(props, option) => (
                          <>
                            <MenuItem {...props} key={option.value} value={option.section}>
                              <ListItemText primary={option.option} />
                            </MenuItem>
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField
                            sx={{
                              '& .MuiAutocomplete-popup': {
                                width: 'auto', // Adjust this to meet the width requirement
                                maxWidth: '100%', // Ensure it does not overflow the viewport
                              },
                              '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                                padding: '8.5px 7px',
                              },
                              '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                                fontSize: '14px',
                              },
                              label: {
                                fontSize: '14px',
                              },
                              '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                                fontSize: '14px',
                              },
                              '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                                color: 'input.font',
                              },
                              '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                                borderColor: 'input.border',
                              },
                              '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                                color: 'input.font',
                              },
                              '.css-14qz1ij-MuiListItemText-root': {
                                margin: '0px',
                              },
                              '.css-wgai2y-MuiFormLabel-asterisk': {
                                color: 'danger.main',
                              },
                              '& .MuiAutocomplete-endAdornment svg': {
                                color: 'black',
                              },
                            }}
                            label={'Less TDS Deductd by Customer'}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            {...params}
                          />
                        )}
                      />

                      <Typography
                        sx={{
                          marginTop: '2px',
                          marginLeft: '10px',
                          marginBottom: '0px',
                          fontSize: '11px',
                          color: 'danger.main',
                        }}
                      >
                        {state?.errorFields.tdsApplicable}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sm={2}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '10px',
                      }}
                    >
                      <Box>
                        <TextField
                          error={state.errorStatus.TDSPercentage == true ? true : false}
                          value={state.TDSPercentage}
                          required={state.tdsApplicable ? true : false}
                          disabled={
                            paymentFlag == false || viewMode === true || currentPaymentFlag == true || !state.tdsApplicable ? true : false
                          }
                          onChange={(e) => {
                            let value = e.target.value;
                            let tdsAmount = 0;
                            tdsAmount = (Number(state.receivableAmount) * Number(value)) / 100;
                            value = value?.replace(/,/g, '');
                            if (!/^\d*(?:\.\d*)?$/.test(value)) {
                              return;
                            }
                            if (value == '') {
                              setState((prev) => ({
                                ...prev,
                                TDSPercentage: value,
                                tdsAmount,
                                TDSManual: 0,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  TDSPercentage: false,
                                  tdsAmount: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  TDSPercentage: '',
                                  tdsAmount: '',
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                TDSPercentage: value,
                                tdsAmount,
                                TDSManual: 0,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  TDSPercentage: false,
                                  tdsAmount: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  TDSPercentage: '',
                                  tdsAmount: '',
                                },
                              }));
                            }
                          }}
                          onKeyDown={handleTdsPercent}
                          id="tdsAmount"
                          label={'TDS'}
                          variant="outlined"
                          size="small"
                          fullWidth
                          sx={{
                            flex: 1,
                            '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                              fontSize: '14px',
                            },
                            label: {
                              fontSize: '14px',
                            },
                            '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                              borderColor: 'input.border',
                            },
                            '.css-12veg18-MuiInputBase-root-MuiOutlinedInput-root': {
                              height: '100%',
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PercentIcon fontSize="14px" />
                              </InputAdornment>
                            ),
                            style: { height: '100%' },
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: '2px',
                            marginLeft: '10px',
                            marginBottom: '0px',
                            fontSize: '11px',
                            color: 'danger.main',
                          }}
                        >
                          {state?.errorFields.TDSPercentage}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={8}
                      sm={4}
                      sx={{
                        textAlign: 'right',
                        marginTop: '10px',
                        // margin: "auto",
                        fontSize: '12px',
                        // paddingRight: "10px",
                        // paddingTop: "10px",
                      }}
                    >
                      {/* ₹                 {state.tdsAmount ? MoneyFormatv3(state.tdsAmount) : 0} */}
                      <MoneyInput
                        state={state}
                        value={state.tdsAmount}
                        onChange={(e) => {
                          let value = e;
                          value = value.replace(/,/g, '');
                          if (!/^\d*(?:\.\d*)?$/.test(value)) {
                            return;
                          }
                          if (/^\d*\.?\d{0,2}$/.test(value) == false) {
                            return;
                          }

                          let amount = 0;
                          if (state.tdsApplicable !== '') {
                            // amount = (value / 100) * state.tdsApplicable;
                            amount = Number(state.TDSPercentage * value) / 100;
                          } else {
                            amount = 0;
                          }
                          if (value == '') {
                            setState((prev) => ({
                              ...prev,
                              TDSManual: 1,
                              tdsAmount: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                payabltdsAmounteAmount: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                tdsAmount: 'TDS Amount is required',
                              },
                            }));
                          } else if (parseFloat(value) > parseFloat(state.receivableAmount)) {
                            setState((prev) => ({
                              ...prev,
                              // tdsAmount: value,
                              TDSManual: 1,
                              errorStatus: {
                                ...prev.errorStatus,
                                tdsAmount: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                tdsAmount: 'TDS cannot be greater than amount paid',
                              },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              TDSManual: 1,
                              tdsAmount: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                tdsAmount: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                tdsAmount: '',
                              },
                            }));
                          }
                        }}
                        label="TDS Amount"
                        id="TDSAmount"
                        name="tdsAmount"
                        variant="outlined"
                        onKeyDown={handleTdsKeyPress}
                        disabled={
                          paymentFlag == false ||
                          viewMode === true ||
                          currentPaymentFlag == true ||
                          !state.tdsApplicable ||
                          (state?.receivedFrom?.AccountTypeFlag != 2 && state?.receivedFrom?.AccountTypeFlag != 1)
                            ? true
                            : false
                        }
                      />
                      <Typography className="error" sx={{ minHeight: '12px', fontSize: '12px' }}>
                        {state?.errorFields.tdsAmount}
                      </Typography>
                    </Grid>

                    <Grid item container xs={12} sx={{ marginTop: '10px' }}>
                      <Grid item xs={8}>
                        <AccountInput
                          error={state?.errorFields.receivedTo}
                          disablePortal
                          label={`Amount Received in ${state.method == 'CashReceipt' ? 'Cash' : 'Bank'} Account`}
                          id="receivedTo"
                          addAccountModal={() => {
                            setAccountFlag(true);
                            if (state.method === 'BankReceipt') {
                              setOpenBankModal(true);
                            } else {
                              setNewPartyID('');
                              setFromAccountModal(true);
                              setOpenModalEvent(true);
                            }
                          }}
                          options={state.method == 'CashReceipt' ? CashAccountsListing : BankAccountsListing}
                          disabled={paymentFlag == false || viewMode == true || currentPaymentFlag == true ? true : false}
                          isOptionEqualToValue={(option, value) => option.value == value?.value}
                          value={state.receivedTo}
                          onChange={(e, newValue) => {
                            if (!newValue) {
                              setState((prev) => ({
                                ...prev,
                                receivedTo: { label: '', value: '' },
                                errorStatus: {
                                  ...prev.errorStatus,
                                  receivedTo: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  receivedTo: '',
                                },
                              }));
                            } else if (newValue === '') {
                              setState((prev) => ({
                                ...prev,
                                receivedTo: newValue,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  receivedTo: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  receivedTo: ' Received To Field Is required',
                                },
                              }));
                            } else if (newValue?.value !== '' && state.receivedFrom.value !== '') {
                              if (newValue?.value === state.receivedFrom.value) {
                                setState((prev) => ({
                                  ...prev,
                                  receivedTo: newValue,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    receivedTo: true,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    receivedTo: ' Received From and Received To should be different',
                                  },
                                }));
                              } else {
                                let accType = '';
                                AllAccountsListing.map((ele) => {
                                  if (ele.value === newValue?.value) {
                                    accType = ele.AccountGroupID;
                                  }
                                });
                                setAccountType(accType);
                                setState((prev) => ({
                                  ...prev,
                                  receivedTo: newValue,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    receivedTo: false,
                                    receivedFrom: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    receivedTo: '',
                                    receivedFrom: '',
                                  },
                                }));
                              }
                            } else {
                              let accType = '';
                              AllAccountsListing.map((ele) => {
                                if (ele.value === newValue?.value) {
                                  accType = ele.AccountGroupID;
                                }
                              });
                              setAccountType(accType);
                              setState((prev) => ({
                                ...prev,
                                receivedTo: newValue,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  receivedTo: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  receivedTo: '',
                                },
                              }));
                            }
                          }}
                        />

                        {state?.errorFields.receivedTo ? (
                          <Typography className="error" sx={{ minHeight: '12px', fontSize: '12px' }}>
                            {state?.errorFields.receivedTo}
                          </Typography>
                        ) : (
                          ''
                        )}

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          {state.receivedTo.value !== '' && state.errorStatus.receivedTo == false && (
                            <Typography
                              sx={{
                                // justifyContent: "flex-end",
                                color:
                                  viewMode == true || paymentFlag == false
                                    ? 'input.border'
                                    : toBalanceAmount < 0
                                    ? 'danger.main'
                                    : 'primary.main',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '12px',
                                '&.MuiTypography-root': {
                                  fontSize: { xs: '10px', lg: '12px' },
                                },
                                // marginTop: { xs: "5px" },
                              }}
                            >
                              {(params?.id
                                ? calculateBalance(
                                    toBalanceAmount +
                                      (Number(amountsFromTable.receivableAmount) -
                                        Number(amountsFromTable.tdsAmount) -
                                        (Number(state.receivableAmount) - Number(state.tdsAmount ?? 0))) *
                                        -1,
                                    true
                                  )
                                : calculateBalance(
                                    toBalanceAmount + (Number(state.receivableAmount) - Number(state.tdsAmount ?? 0)),
                                    true
                                  )) < 0
                                ? state.receivedTo.label + ' ' + 'Balance is negative'
                                : ''}
                            </Typography>
                          )}

                          {state.receivedTo.value !== '' && state.errorStatus.receivedTo == false && (
                            <Typography
                              sx={{
                                // justifyContent: "flex-end",
                                color:
                                  viewMode == true || paymentFlag == false
                                    ? 'input.border'
                                    : params?.id
                                    ? calculateBalance(
                                        toBalanceAmount +
                                          (Number(amountsFromTable.receivableAmount) -
                                            Number(amountsFromTable.tdsAmount) -
                                            (Number(state.receivableAmount) - Number(state.tdsAmount ?? 0))) *
                                            -1,
                                        true
                                      )
                                    : calculateBalance(
                                        toBalanceAmount + (Number(state.receivableAmount) - Number(state.tdsAmount ?? 0)),
                                        true
                                      ) < 0
                                    ? 'danger.main'
                                    : 'primary.main',
                                display: 'flex',
                                alignItems: { xs: 'flex-start', sm: 'center' },
                                flexDirection: 'row',
                                fontSize: '12px',
                                // marginTop: { xs: "-5px" },
                                whiteSpace: 'nowrap',
                                '&.MuiTypography-root': {
                                  fontSize: { xs: '10px', lg: '12px' },
                                },
                              }}
                            >
                              Balance :&nbsp;
                              <a
                                href={`/LedgerTransactions/${state?.receivedTo?.value}`}
                                className="myLink"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setAccountIDTransaction(state?.receivedTo?.value);
                                }}
                                disabled={viewMode == true ? true : false}
                                // color={
                                //   viewMode == true ? "input.border" : "primary.main"
                                // }
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  cursor: 'pointer',
                                  fontSize: '13px',

                                  //   color:
                                  //     viewMode == true || paymentFlag == false
                                  //       ? "input.border"
                                  //       : params?.id
                                  //         ? calculateBalance(
                                  //           toBalanceAmount +
                                  //           (Number(
                                  //             amountsFromTable.receivableAmount
                                  //           ) -
                                  //             Number(amountsFromTable.tdsAmount) -
                                  //             (Number(state.receivableAmount) -
                                  //               Number(state.tdsAmount ?? 0))) *
                                  //           -1,
                                  //           true
                                  //         )
                                  //         : calculateBalance(
                                  //           toBalanceAmount +
                                  //           (Number(state.receivableAmount) -
                                  //             Number(state.tdsAmount ?? 0)),
                                  //           true
                                  //         ) < 0
                                  //           ? "danger.main"
                                  //           : "primary.main",
                                  //   fontSize: "13px",
                                }}
                              >
                                ₹&nbsp;
                                {BalanceAmountCalculator({
                                  balance: ToBalanceAmountv2.balance,
                                  balanceSign: ToBalanceAmountv2.balanceSign,
                                  oldBalance: Number(amountsFromTable.receivableAmount) - Number(amountsFromTable.tdsAmount),
                                  newBalance: Number(state.receivableAmount) - Number(state.tdsAmount ?? 0),
                                  sign: 'debit',
                                  oldAccountid: amountsFromTable.receivedTo?.value,
                                  newAccountid: state?.receivedTo?.value,
                                })}
                                {/* {params?.id
                                ? calculateBalance(
                                  (toBalanceAmount || 0) +
                                  (Number(amountsFromTable.receivableAmount) -
                                    Number(amountsFromTable.tdsAmount) -
                                    (Number(state.receivableAmount) -
                                      Number(state.tdsAmount ?? 0))) *
                                  -1
                                )
                                : calculateBalance(
                                  (toBalanceAmount || 0) +
                                  (Number(state.receivableAmount) -
                                    Number(state.tdsAmount ?? 0))
                                )} */}
                              </a>
                            </Typography>
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={4} sx={{ padding: '0px 10px' }}>
                        <Typography
                          sx={{
                            fontSize: '13px',
                            textAlign: 'right',
                            fontWeight: 'bold',
                          }}
                        >
                          {' '}
                          ₹&nbsp;
                          {state.receivableAmount
                            ? MoneyFormatv3(
                                Number(Number(state.receivableAmount) - (state.tdsAmount ? Number(state.tdsAmount) : 0))?.toFixed(2)
                              )
                            : '0.00'}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          marginBottom: '20px',
                          gap: '10px',
                          marginTop: '10px',
                        }}
                      >
                        <TextField
                          variant="outlined"
                          size="small"
                          fullWidth
                          label="Towards"
                          value={state.Towards}
                          onChange={(e) => {
                            setState((prev) => ({
                              ...prev,
                              Towards: e.target.value,
                            }));
                          }}
                          sx={{
                            width: '50%',
                          }}
                          disabled={viewMode == true || currentPaymentFlag == true ? true : false}
                        />
                        {state.Towards ? (
                          <>
                            <Typography
                              sx={{
                                fontSize: '13px',
                                color: theme?.palette?.TmId.id.toString().includes('9')
                                  ? 'rgba(183, 183, 183, 0.54)'
                                  : 'rgba(0, 0, 0, 0.5)',
                              }}
                            >
                              This will be displayed on the receipt
                            </Typography>
                          </>
                        ) : null}
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item sx={{ marginTop: '24px', marginBottom: '20px' }}>
                <Grid
                  item
                  container
                  md={6}
                  xs={12}
                  style={
                    {
                      // justifyContent: { xs: "center", lg: "flex-start" },
                    }
                  }
                  sx={{ display: { xs: 'block', lg: 'flex' } }}
                >
                  {/* <Grid item lg={1} xs={12}> */}
                  <Typography
                    sx={{
                      marginRight: '10px',
                      fontWeight: 'bold',
                      marginBottom: '5px',
                      color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                    }}
                    variant="h2"
                  >
                    Documents
                  </Typography>
                  {/* </Grid> */}
                  {/* <Grid lg={3} xs={12}> */}
                  {/* <div> */}
                  <input
                    ref={imageRef}
                    type="file"
                    id="fileInput"
                    onChange={handleFileChange}
                    multiple
                    style={{ display: 'none' }}
                    accept="
                    application/msword,
                    application/pdf,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.ms-excel,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    application/vnd.ms-powerpoint,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    image/jpeg,
                    image/jpg,
                    image/png
                  "
                  />
                  <CustomTooltip title="Rolling out soon" placement="top">
                    <span>
                      <Button
                        onClick={() => imageRef?.current?.click()}
                        size="small"
                        variant="contained"
                        // disabled={params?.view}
                        disabled={true}
                        sx={{
                          fontSize: '12px',
                          padding: '5px 7px',
                          marginBottom: '5px',
                          boxShadow: 'none',
                          marginTop: '-3px',
                          display: params?.view ? 'none' : 'block',
                        }}
                      >
                        <AddIcon fontSize="15px" />
                        {' ADD DOCUMENT'}
                        {attachments.length > 0 && <span style={{ color: 'white' }}>{'\xa0' + `(${attachments.length} out of 6)`}</span>}
                      </Button>
                    </span>
                  </CustomTooltip>

                  {/* </div> */}
                  {/* </Grid> */}

                  {attachments.length > 0 && (
                    <Grid lg={12}>
                      <Attachment
                        view={params?.view}
                        attachments={attachments}
                        setAttachments={setAttachments}
                        updateAttachmentName={updateAttachmentName}
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid item xs={12} md={6}>
                  {vouchers.length > 0 && (
                    <>
                      <Grid>
                        <LinkingTable
                          type="receipt"
                          key={'link'}
                          disabled={paymentFlag == false || viewMode == true || currentPaymentFlag == true ? true : false}
                          data={vouchers}
                          onChange={handleLinkedAmount}
                        />
                        <Typography sx={{ marginTop: '5px', textAlign: 'right' }}>
                          Balance in Receipt : {MoneyFormatv3(balanceInReceipt())}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {Enable_ItemWiseEntry ? (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'end',
                          alignItems: 'center',
                          '.css-1kpioai-MuiButtonBase-root-MuiCheckbox-root': {
                            // color:'#f0f1f6'
                            color: 'input.border',
                          },
                          '.css-1kpioai-MuiButtonBase-root-MuiCheckbox-root.Mui-checked': {
                            color: 'primary.main',
                          },
                          marginRight: '10px',
                        }}
                      >
                        {/* <Box
                      disabled={
                        viewMode == true && state.receivedFrom.value == ""
                          ? true
                          : false
                      }
                      color={
                        viewMode == true && state.receivedFrom.value == ""
                          ? "input.border"
                          : "primary.main"
                      }
                      href="#"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                        cursor: viewMode == true ? "default" : "pointer",
                        color:
                          state.method !== "" &&
                          viewMode != true &&
                          state.receivedFrom.value != ""
                            ? "primary.main"
                            : "input.border",
                      }}
                      onClick={(event) => {
                        event.preventDefault();
                        if (viewMode != true && state.receivedFrom.value !== "") {
                          setLinkToInvoiceModal(true);
                        } else {
                          setLinkToInvoiceModal(false);
                        }
                      }}
                    >
                      <LinkIcon
                        disabled={
                          viewMode == true && state.receivedFrom.value == ""
                            ? true
                            : false
                        }
                        fontSize="small"
                        sx={{
                          margin: "8px",
                          marginLeft: "0",
                          color:
                            viewMode != true && state.receivedFrom.value !== ""
                              ? "primary.main"
                              : "input.border",
                        }}
                      />
                      Link to Invoice
                    </Box> */}
                      </Box>
                    </Grid>
                  ) : (
                    ''
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
        {/* <FloatingButton
          setCancelModal={setCancelModal}
          saveChanges={() => {
            saveChanges({ new: false });
          }}
          saveChangesPrint={() => {
            saveChanges({ print: true, preview: false });
            // handlePrint(state.vouchernumber)
          }}
          saveEditChanges={() => saveEditChanges()}
          saveandNew={() => saveChanges({ new: true })}
          saveChangesFlag={true}
          isModal={modalEvent}
          setPreviewModal={setPreviewReceiptModal}
          previewLabel="Preview Invoice"
          printButton={true}
          paramsID={params?.id}
          paramsView={params?.view}
          onPrint={handlePrint}
        /> */}
        {/* {(viewMode == true ? entryData?.cancelflag === 0 : true) ? ( */}
        <DraggableAction
          actionType={params?.id && params?.view !== true ? 'edit' : entryData?.cancelflag === 1 ? 'cancelled' : 'save'}
          from={'receipt'}
          onExit={() => {
            // setCancelModal(true);
            navigate('/receipts');
          }}
          onSave={
            params?.id && params?.view !== true
              ? () => {
                  saveEditChanges();
                }
              : params?.view !== true
              ? () => saveChanges({ new: false })
              : null
          }
          onEnableEdit={() => {
            setViewMode(false);
            navigate('/editreceipts', {
              state: { id: entryData.transactionid },
            });
          }}
          onPrint={params?.view == true || params?.id ? () => fetchAndPrintPDF(uri) : null}
          onCancel={
            params?.view == true || params?.id
              ? () => {
                  setCancelModalStatus(true);
                  setItemData({
                    id: entryData?.transactionid,
                    nav: '/receipts',
                    todo: 'cancel',
                    from: 'Receipt',
                    fn: () => cancel(entryData?.transactionid, entryData?.transactiontypecd, entryData?.vouchernumber),
                  });
                }
              : null
          }
          onDelete={
            params?.view == true || params?.id
              ? () => {
                  setDeleteItemModal(true);
                  setItemData({
                    id: entryData?.transactionid,
                    label: 'Receipt',
                    from: 'Receipt',
                    todo: 'delete',
                    nav: '/receipts',
                  });
                }
              : null
          }
          onPreview={() => {
            setPreviewReceiptModal(true);
          }}
          onSaveNew={params?.view !== true ? () => saveChanges({ new: true }) : null}
          onReset={
            params?.view !== true
              ? () => {
                  setState(initialState);
                }
              : null
          }
        />
        {/* ) : null} */}
        {deleteItemModal == true ? (
          // <DeletePaymentEntry
          //   open={deleteItemModal}
          //   setOpen={setDeleteItemModal}
          //   itemData={itemData}
          // />
          <InvoiceCancel
            state={data}
            setState={setData}
            open={deleteItemModal}
            vouchers={vouchers}
            setOpen={setDeleteItemModal}
            onConfirm={() => {
              deleteEntry(itemData);
              setDeleteItemModal(false);
            }}
            itemData={itemData}
          />
        ) : null}
        {cancelModalStatus == true ? (
          <InvoiceCancel
            state={data}
            vouchers={vouchers}
            setState={setData}
            open={cancelModalStatus}
            setOpen={setCancelModalStatus}
            itemData={itemData}
          />
        ) : null}
      </Box>
      {linkToInvoiceModal === true && (
        <LinkToSalesInvoice
          open={linkToInvoiceModal}
          setOpen={setLinkToInvoiceModal}
          setTransArr={setTransArr}
          entryData={entryData}
          accountID={accountID}
          showWarningSnackbar={showWarningSnackbar}
          setLinkedData={setLinkedData}
          receiptDetails={state}
        />
      )}
      {openModalEvent === true && (
        //  <CreateAndEditLedger  open={fromAccountModal} setOpen={setFromAccountModal} tab={""} setData={setState}  />
        <AddAccountModal
          open={fromAccountModal}
          setOpen={setFromAccountModal}
          setData={setState}
          data={state}
          accountType={accountFlag === true ? (state.method === 'CashReceipt' ? 'Cash' : 'Bank') : 'receivedFrom'}
          showSuccessSnackbar={showSuccessSnackbar}
          showWarningSnackbar={showWarningSnackbar}
          showErrorSnackbar={showErrorSnackbar}
          Type={'Receipt'}
          companyData={getCompany}
          setNewPartyName={setNewPartyName}
          newPartyName={newPartyName}
          setNewPartyID={setNewPartyID}
          newPartyID={newPartyID}
          setSelectedGroupId={setSelectedGroupId}
          selelctedGroupId={selelctedGroupId}
          // setAllAccount={setAccountName}
          listAccounts={getAccountMasterData}
        />
      )}
      {openBankModal === true && (
        <AddBankAccountModal
          open={openBankModal}
          setOpen={setOpenBankModal}
          showSuccessSnackbar={showSuccessSnackbar}
          showWarningSnackbar={showWarningSnackbar}
          showErrorSnackbar={showErrorSnackbar}
          setData={setState}
          data={state}
          companyData={getCompany}
          accountType={'Receipt'}
          listAccounts={getAccountMasterData}
        />
      )}
      {settingsModal === true && <NewVoucherSettingsModal open={settingsModal} label="Receipt" type="Receipt" setOpen={setSettingsModal} />}

      <PreviewSalesTaxable open={previewReceiptModal} setOpen={setPreviewReceiptModal} getHtml={handlePrint} type={'receipt'} />

      <ConfirmCancel open={cancelModal} setOpen={setCancelModal} path="receipts" />
      {accountIDTransaction && (
        <LedgerTransactionModalv2
          open={accountIDTransaction}
          accountId={accountIDTransaction}
          onClose={() => setAccountIDTransaction('')}
        />
      )}

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropOpen || isAccountMasterLoading || LoadingLastAccount}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <CaptureTcsTds onClose={() => { setopenCaptureTCSTDS(false) }} value={{ TAN: state.TAN, PartyName: state.PartyName }} open={openCaptureTCSTDS} onSave={(data) => {
        setState((prev) => ({ ...prev, ...data }))
      }} /> */}
      <SummaryDialog data={SummaryData} onClose={() => onSaveComplete()} />
    </Box>
  );
}

export default memo(AddNewReceipts);
